import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createTextVNode as o, createVNode as s, customRef as c, defineComponent as l, getCurrentInstance as u, h as d, inject as f, markRaw as p, mergeProps as m, normalizeClass as h, onBeforeUnmount as g, onMounted as _, openBlock as v, ref as y, renderList as b, resolveComponent as x, resolveDynamicComponent as S, toDisplayString as C, vModelText as w, watch as T, withCtx as E, withDirectives as D, withKeys as O } from "vue";
import k from "moment";
import { log as A } from "@vue-skuilder/common";
import { defineStore as ee, setActivePinia as j } from "pinia";
//#region \0rolldown/runtime.js
var M = Object.create, N = Object.defineProperty, __name = (e, t) => N(e, "name", {
	value: t,
	configurable: !0
}), te = Object.getOwnPropertyDescriptor, P = Object.getOwnPropertyNames, ne = Object.getPrototypeOf, re = Object.prototype.hasOwnProperty, __commonJSMin = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), __exportAll = (e, t) => {
	let n = {};
	for (var r in e) N(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || N(n, Symbol.toStringTag, { value: "Module" }), n;
}, __copyProps = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = P(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !re.call(e, s) && s !== n && N(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = te(t, s)) || r.enumerable
	});
	return e;
}, __toESM = (e, t, n) => (n = e == null ? {} : M(ne(e)), __copyProps(t || !e || !e.__esModule ? N(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), F = /* @__PURE__ */ __name((e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, "default"), ie = /* @__PURE__ */ __commonJSMin(((e, t) => {
	(function(e, n, r) {
		if (!e) return;
		for (var i = {
			8: "backspace",
			9: "tab",
			13: "enter",
			16: "shift",
			17: "ctrl",
			18: "alt",
			20: "capslock",
			27: "esc",
			32: "space",
			33: "pageup",
			34: "pagedown",
			35: "end",
			36: "home",
			37: "left",
			38: "up",
			39: "right",
			40: "down",
			45: "ins",
			46: "del",
			91: "meta",
			93: "meta",
			224: "meta"
		}, a = {
			106: "*",
			107: "+",
			109: "-",
			110: ".",
			111: "/",
			186: ";",
			187: "=",
			188: ",",
			189: "-",
			190: ".",
			191: "/",
			192: "`",
			219: "[",
			220: "\\",
			221: "]",
			222: "'"
		}, o = {
			"~": "`",
			"!": "1",
			"@": "2",
			"#": "3",
			$: "4",
			"%": "5",
			"^": "6",
			"&": "7",
			"*": "8",
			"(": "9",
			")": "0",
			_: "-",
			"+": "=",
			":": ";",
			"\"": "'",
			"<": ",",
			">": ".",
			"?": "/",
			"|": "\\"
		}, s = {
			option: "alt",
			command: "meta",
			return: "enter",
			escape: "esc",
			plus: "+",
			mod: /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
		}, c, l = 1; l < 20; ++l) i[111 + l] = "f" + l;
		for (l = 0; l <= 9; ++l) i[l + 96] = l.toString();
		function _addEvent(e, t, n) {
			if (e.addEventListener) {
				e.addEventListener(t, n, !1);
				return;
			}
			e.attachEvent("on" + t, n);
		}
		function _characterFromEvent(e) {
			if (e.type == "keypress") {
				var t = String.fromCharCode(e.which);
				return e.shiftKey || (t = t.toLowerCase()), t;
			}
			return i[e.which] ? i[e.which] : a[e.which] ? a[e.which] : String.fromCharCode(e.which).toLowerCase();
		}
		function _modifiersMatch(e, t) {
			return e.sort().join(",") === t.sort().join(",");
		}
		function _eventModifiers(e) {
			var t = [];
			return e.shiftKey && t.push("shift"), e.altKey && t.push("alt"), e.ctrlKey && t.push("ctrl"), e.metaKey && t.push("meta"), t;
		}
		function _preventDefault(e) {
			if (e.preventDefault) {
				e.preventDefault();
				return;
			}
			e.returnValue = !1;
		}
		function _stopPropagation(e) {
			if (e.stopPropagation) {
				e.stopPropagation();
				return;
			}
			e.cancelBubble = !0;
		}
		function _isModifier(e) {
			return e == "shift" || e == "ctrl" || e == "alt" || e == "meta";
		}
		function _getReverseMap() {
			if (!c) for (var e in c = {}, i) e > 95 && e < 112 || i.hasOwnProperty(e) && (c[i[e]] = e);
			return c;
		}
		function _pickBestAction(e, t, n) {
			return n || (n = _getReverseMap()[e] ? "keydown" : "keypress"), n == "keypress" && t.length && (n = "keydown"), n;
		}
		function _keysFromString(e) {
			return e === "+" ? ["+"] : (e = e.replace(/\+{2}/g, "+plus"), e.split("+"));
		}
		function _getKeyInfo(e, t) {
			var n, r, i, a = [];
			for (n = _keysFromString(e), i = 0; i < n.length; ++i) r = n[i], s[r] && (r = s[r]), t && t != "keypress" && o[r] && (r = o[r], a.push("shift")), _isModifier(r) && a.push(r);
			return t = _pickBestAction(r, a, t), {
				key: r,
				modifiers: a,
				action: t
			};
		}
		function _belongsTo(e, t) {
			return e === null || e === n ? !1 : e === t ? !0 : _belongsTo(e.parentNode, t);
		}
		function Mousetrap(e) {
			var t = this;
			if (e = e || n, !(t instanceof Mousetrap)) return new Mousetrap(e);
			t.target = e, t._callbacks = {}, t._directMap = {};
			var r = {}, i, a = !1, o = !1, s = !1;
			function _resetSequences(e) {
				e = e || {};
				var t = !1, n;
				for (n in r) {
					if (e[n]) {
						t = !0;
						continue;
					}
					r[n] = 0;
				}
				t || (s = !1);
			}
			function _getMatches(e, n, i, a, o, s) {
				var c, l, u = [], d = i.type;
				if (!t._callbacks[e]) return [];
				for (d == "keyup" && _isModifier(e) && (n = [e]), c = 0; c < t._callbacks[e].length; ++c) if (l = t._callbacks[e][c], !(!a && l.seq && r[l.seq] != l.level) && d == l.action && (d == "keypress" && !i.metaKey && !i.ctrlKey || _modifiersMatch(n, l.modifiers))) {
					var f = !a && l.combo == o, p = a && l.seq == a && l.level == s;
					(f || p) && t._callbacks[e].splice(c, 1), u.push(l);
				}
				return u;
			}
			function _fireCallback(e, n, r, i) {
				t.stopCallback(n, n.target || n.srcElement, r, i) || e(n, r) === !1 && (_preventDefault(n), _stopPropagation(n));
			}
			t._handleKey = function(e, t, n) {
				var r = _getMatches(e, t, n), i, a = {}, c = 0, l = !1;
				for (i = 0; i < r.length; ++i) r[i].seq && (c = Math.max(c, r[i].level));
				for (i = 0; i < r.length; ++i) {
					if (r[i].seq) {
						if (r[i].level != c) continue;
						l = !0, a[r[i].seq] = 1, _fireCallback(r[i].callback, n, r[i].combo, r[i].seq);
						continue;
					}
					l || _fireCallback(r[i].callback, n, r[i].combo);
				}
				var u = n.type == "keypress" && o;
				n.type == s && !_isModifier(e) && !u && _resetSequences(a), o = l && n.type == "keydown";
			};
			function _handleKeyEvent(e) {
				typeof e.which != "number" && (e.which = e.keyCode);
				var n = _characterFromEvent(e);
				if (n) {
					if (e.type == "keyup" && a === n) {
						a = !1;
						return;
					}
					t.handleKey(n, _eventModifiers(e), e);
				}
			}
			function _resetSequenceTimer() {
				clearTimeout(i), i = setTimeout(_resetSequences, 1e3);
			}
			function _bindSequence(e, t, n, i) {
				r[e] = 0;
				function _increaseSequence(t) {
					return function() {
						s = t, ++r[e], _resetSequenceTimer();
					};
				}
				function _callbackAndReset(t) {
					_fireCallback(n, t, e), i !== "keyup" && (a = _characterFromEvent(t)), setTimeout(_resetSequences, 10);
				}
				for (var o = 0; o < t.length; ++o) {
					var c = o + 1 === t.length ? _callbackAndReset : _increaseSequence(i || _getKeyInfo(t[o + 1]).action);
					_bindSingle(t[o], c, i, e, o);
				}
			}
			function _bindSingle(e, n, r, i, a) {
				t._directMap[e + ":" + r] = n, e = e.replace(/\s+/g, " ");
				var o = e.split(" "), s;
				if (o.length > 1) {
					_bindSequence(e, o, n, r);
					return;
				}
				s = _getKeyInfo(e, r), t._callbacks[s.key] = t._callbacks[s.key] || [], _getMatches(s.key, s.modifiers, { type: s.action }, i, e, a), t._callbacks[s.key][i ? "unshift" : "push"]({
					callback: n,
					modifiers: s.modifiers,
					action: s.action,
					seq: i,
					level: a,
					combo: e
				});
			}
			t._bindMultiple = function(e, t, n) {
				for (var r = 0; r < e.length; ++r) _bindSingle(e[r], t, n);
			}, _addEvent(e, "keypress", _handleKeyEvent), _addEvent(e, "keydown", _handleKeyEvent), _addEvent(e, "keyup", _handleKeyEvent);
		}
		Mousetrap.prototype.bind = function(e, t, n) {
			var r = this;
			return e = e instanceof Array ? e : [e], r._bindMultiple.call(r, e, t, n), r;
		}, Mousetrap.prototype.unbind = function(e, t) {
			var n = this;
			return n.bind.call(n, e, function() {}, t);
		}, Mousetrap.prototype.trigger = function(e, t) {
			var n = this;
			return n._directMap[e + ":" + t] && n._directMap[e + ":" + t]({}, e), n;
		}, Mousetrap.prototype.reset = function() {
			var e = this;
			return e._callbacks = {}, e._directMap = {}, e;
		}, Mousetrap.prototype.stopCallback = function(e, t) {
			var n = this;
			if ((" " + t.className + " ").indexOf(" mousetrap ") > -1 || _belongsTo(t, n.target)) return !1;
			if ("composedPath" in e && typeof e.composedPath == "function") {
				var r = e.composedPath()[0];
				r !== e.target && (t = r);
			}
			return t.tagName == "INPUT" || t.tagName == "SELECT" || t.tagName == "TEXTAREA" || t.isContentEditable;
		}, Mousetrap.prototype.handleKey = function() {
			var e = this;
			return e._handleKey.apply(e, arguments);
		}, Mousetrap.addKeycodes = function(e) {
			for (var t in e) e.hasOwnProperty(t) && (i[t] = e[t]);
			c = null;
		}, Mousetrap.init = function() {
			var e = Mousetrap(n);
			for (var t in e) t.charAt(0) !== "_" && (Mousetrap[t] = function(t) {
				return function() {
					return e[t].apply(e, arguments);
				};
			}(t));
		}, Mousetrap.init(), e.Mousetrap = Mousetrap, t !== void 0 && t.exports && (t.exports = Mousetrap), typeof define == "function" && define.amd && define(function() {
			return Mousetrap;
		});
	})(typeof window < "u" ? window : null, typeof window < "u" ? document : null);
}));
//#endregion
//#region \0@oxc-project+runtime@0.115.0/helpers/typeof.js
function _typeof(e) {
	"@babel/helpers - typeof";
	return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, _typeof(e);
}
//#endregion
//#region \0@oxc-project+runtime@0.115.0/helpers/toPrimitive.js
function toPrimitive(e, t) {
	if (_typeof(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (_typeof(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
//#endregion
//#region \0@oxc-project+runtime@0.115.0/helpers/toPropertyKey.js
function toPropertyKey(e) {
	var t = toPrimitive(e, "string");
	return _typeof(t) == "symbol" ? t : t + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.115.0/helpers/defineProperty.js
function _defineProperty(e, t, n) {
	return (t = toPropertyKey(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
//#endregion
//#region src/utils/SkldrMouseTrap.ts
var ae = /* @__PURE__ */ __toESM(ie());
function inputElementIsFocused() {
	let e = document.activeElement;
	return e instanceof HTMLInputElement && (e.type === "checkbox" || e.type === "radio") ? !1 : e instanceof HTMLElement && (e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.tagName === "SELECT" || e.isContentEditable);
}
var I = class SkldrMouseTrap {
	constructor() {
		_defineProperty(this, "mouseTrap", void 0), _defineProperty(this, "hotkeys", void 0), this.mouseTrap = new ae.default(), this.mouseTrap.stopCallback = () => !1, this.hotkeys = [];
	}
	static get commands() {
		return SkldrMouseTrap.instance().hotkeys.map((e) => ({
			command: e.command,
			hotkey: e.hotkey
		}));
	}
	static addBinding(e) {
		let t = Array.isArray(e) ? e : [e], n = SkldrMouseTrap.instance();
		n.hotkeys = [...n.hotkeys, ...t], t.forEach((e) => {
			n.mouseTrap.bind(e.hotkey, (t, n) => {
				if (inputElementIsFocused()) {
					console.log(`Ignoring hotkey ${e.hotkey} while input element is focused`);
					return;
				}
				e.callback(t, n);
			});
		});
	}
	static removeBinding(e) {
		let t = SkldrMouseTrap.instance(), n = [...t.hotkeys];
		Array.isArray(e) && !e.every((e) => typeof e == "string" || typeof e == "number") ? e.forEach((e) => {
			t.hotkeys = t.hotkeys.filter((t) => JSON.stringify(t.hotkey) !== JSON.stringify(e)), t.mouseTrap.unbind(e);
		}) : (t.hotkeys = n.filter((t) => JSON.stringify(t.hotkey) !== JSON.stringify(e)), t.mouseTrap.unbind(e));
	}
	static reset() {
		console.warn("SkldrMouseTrap.reset() may affect hotkeys registered by other components. Consider using removeBinding() with specific hotkeys for better component isolation."), SkldrMouseTrap.instance().mouseTrap.reset(), SkldrMouseTrap.instance().hotkeys = [];
	}
	static instance() {
		return SkldrMouseTrap._instance || (SkldrMouseTrap._instance = new SkldrMouseTrap()), SkldrMouseTrap._instance;
	}
};
_defineProperty(I, "_instance", void 0);
//#endregion
//#region src/composables/CompositionViewable.ts
function useViewable(e, t, n) {
	let r = y(k.utc()), i = y([]), a = {
		log: (e, ...t) => console.log(`[${n}]: `, e, ...t),
		error: (e, ...t) => console.error(`[${n}]: `, e, ...t),
		warn: (e, ...t) => console.warn(`[${n}]: `, e, ...t)
	}, o = c(() => ({
		get: () => Math.abs(k.utc().diff(r.value, "milliseconds")),
		set: () => {}
	})), getURL = (t, n = 0) => {
		try {
			if (e.data[n]?.[t]) return URL.createObjectURL(e.data[n][t]);
		} catch (e) {
			a.error("Error creating URL for item:", t, e);
		}
		return "";
	}, emitResponse = (e) => {
		t("emitResponse", e);
	};
	return {
		startTime: r,
		hotKeys: i,
		timeSpent: o,
		logger: a,
		getURL,
		emitResponse
	};
}
function useQuestionView(e) {
	let t = y(0), n = y(0), r = y([]), i = y(3), a = y(2), o = y(), submitAnswer = (t, i, a) => {
		if (e.logger.log("submitAnswer called..."), !o.value) throw Error("Question not initialized");
		r.value.push([t, i ?? ""]);
		let s = e.timeSpent.value, c = o.value.evaluate(t, s);
		e.logger.log(`evaluation of answer ${t}:`, c);
		let l = {
			...c,
			priorAttemps: n.value,
			courseID: "",
			cardID: "",
			timeSpent: s,
			timeStamp: e.startTime.value,
			userAnswer: t
		};
		return a?.deferAdvance !== void 0 && (l.deferAdvance = a.deferAdvance), c.isCorrect || n.value++, e.emitResponse(l), l;
	};
	return {
		priorSessionViews: t,
		priorAttempts: n,
		priorAnswers: r,
		maxAttemptsPerView: i,
		maxSessionViews: a,
		question: o,
		submitAnswer
	};
}
function isQuestionView(e) {
	return typeof e == "object" && !!e && "submitAnswer" in e && "priorAttempts" in e;
}
//#endregion
//#region src/plugins/pinia.ts
var oe = null, setPinia = (e) => {
	oe = e;
}, getPinia = () => oe, se = { install(e, t) {
	let n = t?.pinia;
	n && setPinia(n);
} }, useCardPreviewModeStore = () => {
	let e = getPinia();
	return e && j(e), ee("previewMode", {
		state: () => ({ previewMode: !1 }),
		actions: { setPreviewMode(e) {
			this.previewMode = e;
		} },
		getters: { isPreviewMode() {
			return this.previewMode;
		} }
	})();
}, ce = l({
	name: "UserInput",
	data() {
		return {
			answer: "",
			previewModeStore: null
		};
	},
	mounted() {
		this.previewModeStore = useCardPreviewModeStore();
	},
	computed: {
		autofocus() {
			return !this.previewModeStore?.previewMode;
		},
		autoFocus() {
			return this.autofocus;
		}
	},
	methods: {
		submitAnswer(e) {
			return this.submit(e);
		},
		submit(e) {
			return this.getQuestionViewAncestor().submitAnswer(e, this.$options.name ?? "UserInput");
		},
		getQuestionViewAncestor() {
			let e = this.$parent, t = 0;
			for (; e && !isQuestionView(e);) {
				let n = e.$parent;
				if (!n) {
					let e = "\nUserInput.submit() has failed.\nThe input element has no QuestionView ancestor element.";
					throw A(e), Error(e);
				}
				if (e = n, t++, t > 100) {
					let e = "\nUserInput.submit() has failed.\nExceeded maximum ancestor lookup depth.";
					throw A(e), Error(e);
				}
			}
			if (!e) throw Error("No QuestionView ancestor found");
			return e;
		}
	}
}), le = l({
	name: "UserInputString",
	extends: ce,
	props: { icon: {
		type: Boolean,
		required: !1
	} },
	computed: { prependIcon() {
		return this.icon ? "edit" : "";
	} },
	mounted() {
		this.$refs.input?.focus();
	},
	methods: {}
}), ue = { class: "user-input-container" }, de = ["autofocus"];
function _sfc_render$2(e, t, n, r, o, s) {
	return v(), i("span", ue, [D(a("input", {
		"onUpdate:modelValue": t[0] || (t[0] = (t) => e.answer = t),
		autofocus: e.autofocus,
		type: "text",
		class: "user-input-string",
		ref: "input",
		onKeyup: t[1] || (t[1] = O((t) => e.submitAnswer(e.answer), ["enter"]))
	}, null, 40, de), [[w, e.answer]])]);
}
__name(_sfc_render$2, "_sfc_render");
var fe = /* @__PURE__ */ F(le, [["render", _sfc_render$2], ["__scopeId", "data-v-aa14961f"]]), pe = l({
	name: "FillInInput",
	components: { UserInputString: fe },
	props: { text: {
		type: String,
		required: !0
	} },
	setup(e) {
		let n = y("text"), r = y(""), i = t(() => e.text.split("||").length > 1);
		return _(() => {
			console.log(`fillinCreated w/ text: ${e.text}`), r.value = e.text.substring(2, e.text.length - 2), console.log(`fillin text trimmed to: ${r.value}`), r.value.split("||").length > 1 && (n.value = "radio");
		}), {
			inputType: n,
			radioType: i,
			processedText: r
		};
	}
}), me = {
	key: 0,
	class: "text-h5 underline"
};
function _sfc_render$1(e, t, r, a, o, s) {
	let c = x("user-input-string");
	return e.radioType ? (v(), i("span", me, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0")) : (v(), n(c, {
		key: 1,
		id: "input",
		icon: !1,
		type: "text",
		value: e.processedText
	}, null, 8, ["value"]));
}
__name(_sfc_render$1, "_sfc_render");
var he = /* @__PURE__ */ F(pe, [["render", _sfc_render$1], ["__scopeId", "data-v-486ac035"]]);
//#endregion
//#region ../../node_modules/marked/lib/marked.esm.js
function _getDefaults() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var L = _getDefaults();
function changeDefaults(e) {
	L = e;
}
var R = { exec: () => null };
function edit(e, t = "") {
	let n = typeof e == "string" ? e : e.source, r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace(z.caret, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
var z = {
	codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
	outputLinkReplace: /\\([\[\]])/g,
	indentCodeCompensation: /^(\s+)(?:```)/,
	beginningSpace: /^\s+/,
	endingHash: /#$/,
	startingSpaceChar: /^ /,
	endingSpaceChar: / $/,
	nonSpaceChar: /[^ ]/,
	newLineCharGlobal: /\n/g,
	tabCharGlobal: /\t/g,
	multipleSpaceGlobal: /\s+/g,
	blankLine: /^[ \t]*$/,
	doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
	blockquoteStart: /^ {0,3}>/,
	blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
	blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
	listReplaceTabs: /^\t+/,
	listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
	listIsTask: /^\[[ xX]\] /,
	listReplaceTask: /^\[[ xX]\] +/,
	anyLine: /\n.*\n/,
	hrefBrackets: /^<(.*)>$/,
	tableDelimiter: /[:|]/,
	tableAlignChars: /^\||\| *$/g,
	tableRowBlankLine: /\n[ \t]*$/,
	tableAlignRight: /^ *-+: *$/,
	tableAlignCenter: /^ *:-+: *$/,
	tableAlignLeft: /^ *:-+ *$/,
	startATag: /^<a /i,
	endATag: /^<\/a>/i,
	startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
	endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
	startAngleBracket: /^</,
	endAngleBracket: />$/,
	pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
	unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
	escapeTest: /[&<>"']/,
	escapeReplace: /[&<>"']/g,
	escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
	escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
	unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi,
	caret: /(^|[^\[])\^/g,
	percentDecode: /%25/g,
	findPipe: /\|/g,
	splitPipe: / \|/,
	slashPipe: /\\\|/g,
	carriageReturn: /\r\n|\r/g,
	spaceLine: /^ +$/gm,
	notSpaceStart: /^\S*/,
	endingNewline: /\n$/,
	listItemRegex: (e) => RegExp(`^( {0,3}${e})((?:[\t ][^\\n]*)?(?:\\n|$))`),
	nextBulletRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`),
	hrRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
	fencesBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}(?:\`\`\`|~~~)`),
	headingBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}#`),
	htmlBeginRegex: (e) => RegExp(`^ {0,${Math.min(3, e - 1)}}<(?:[a-z].*>|!--)`, "i")
}, ge = /^(?:[ \t]*(?:\n|$))+/, _e = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, ve = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, B = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, ye = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, V = /(?:[*+-]|\d{1,9}[.)])/, be = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, xe = edit(be).replace(/bull/g, V).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Se = edit(be).replace(/bull/g, V).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), H = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Ce = /^[^\n]+/, U = /(?!\s*\])(?:\\.|[^\[\]\\])+/, we = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", U).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Te = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, V).getRegex(), W = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", Ee = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, De = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", Ee).replace("tag", W).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), Oe = edit(H).replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", W).getRegex(), ke = {
	blockquote: edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", Oe).getRegex(),
	code: _e,
	def: we,
	fences: ve,
	heading: ye,
	hr: B,
	html: De,
	lheading: xe,
	list: Te,
	newline: ge,
	paragraph: Oe,
	table: R,
	text: Ce
}, Ae = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", W).getRegex(), je = {
	...ke,
	lheading: Se,
	table: Ae,
	paragraph: edit(H).replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", Ae).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", W).getRegex()
}, Me = {
	...ke,
	html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", Ee).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: R,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: edit(H).replace("hr", B).replace("heading", " *#{1,6} *[^\n]").replace("lheading", xe).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, Ne = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, Pe = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, Fe = /^( {2,}|\\)\n(?!\s*$)/, Ie = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, G = /[\p{P}\p{S}]/u, Le = /[\s\p{P}\p{S}]/u, Re = /[^\s\p{P}\p{S}]/u, ze = edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, Le).getRegex(), Be = /(?!~)[\p{P}\p{S}]/u, Ve = /(?!~)[\s\p{P}\p{S}]/u, He = /(?:[^\s\p{P}\p{S}]|~)/u, Ue = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g, We = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/, Ge = edit(We, "u").replace(/punct/g, G).getRegex(), Ke = edit(We, "u").replace(/punct/g, Be).getRegex(), qe = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", Je = edit(qe, "gu").replace(/notPunctSpace/g, Re).replace(/punctSpace/g, Le).replace(/punct/g, G).getRegex(), Ye = edit(qe, "gu").replace(/notPunctSpace/g, He).replace(/punctSpace/g, Ve).replace(/punct/g, Be).getRegex(), Xe = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, Re).replace(/punctSpace/g, Le).replace(/punct/g, G).getRegex(), Ze = edit(/\\(punct)/, "gu").replace(/punct/g, G).getRegex(), Qe = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), $e = edit(Ee).replace("(?:-->|$)", "-->").getRegex(), et = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", $e).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), K = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, tt = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", K).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), nt = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", K).replace("ref", U).getRegex(), rt = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", U).getRegex(), it = {
	_backpedal: R,
	anyPunctuation: Ze,
	autolink: Qe,
	blockSkip: Ue,
	br: Fe,
	code: Pe,
	del: R,
	emStrongLDelim: Ge,
	emStrongRDelimAst: Je,
	emStrongRDelimUnd: Xe,
	escape: Ne,
	link: tt,
	nolink: rt,
	punctuation: ze,
	reflink: nt,
	reflinkSearch: edit("reflink|nolink(?!\\()", "g").replace("reflink", nt).replace("nolink", rt).getRegex(),
	tag: et,
	text: Ie,
	url: R
}, at = {
	...it,
	link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", K).getRegex(),
	reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", K).getRegex()
}, ot = {
	...it,
	emStrongRDelimAst: Ye,
	emStrongLDelim: Ke,
	url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
	text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, st = {
	...ot,
	br: edit(Fe).replace("{2,}", "*").getRegex(),
	text: edit(ot.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, q = {
	normal: ke,
	gfm: je,
	pedantic: Me
}, J = {
	normal: it,
	gfm: ot,
	breaks: st,
	pedantic: at
}, ct = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, getEscapeReplacement = (e) => ct[e];
function escape(e, t) {
	if (t) {
		if (z.escapeTest.test(e)) return e.replace(z.escapeReplace, getEscapeReplacement);
	} else if (z.escapeTestNoEncode.test(e)) return e.replace(z.escapeReplaceNoEncode, getEscapeReplacement);
	return e;
}
function cleanUrl(e) {
	try {
		e = encodeURI(e).replace(z.percentDecode, "%");
	} catch {
		return null;
	}
	return e;
}
function splitCells(e, t) {
	let n = e.replace(z.findPipe, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(z.splitPipe), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), t) if (n.length > t) n.splice(t);
	else for (; n.length < t;) n.push("");
	for (; r < n.length; r++) n[r] = n[r].trim().replace(z.slashPipe, "|");
	return n;
}
function rtrim(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r && e.charAt(r - i - 1) === t;) i++;
	return e.slice(0, r - i);
}
function findClosingBracket(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return -1;
}
function outputLink(e, t, n, r, i) {
	let a = t.href, o = t.title || null, s = e[1].replace(i.other.outputLinkReplace, "$1");
	if (e[0].charAt(0) !== "!") {
		r.state.inLink = !0;
		let e = {
			type: "link",
			raw: n,
			href: a,
			title: o,
			text: s,
			tokens: r.inlineTokens(s)
		};
		return r.state.inLink = !1, e;
	}
	return {
		type: "image",
		raw: n,
		href: a,
		title: o,
		text: s
	};
}
function indentCodeCompensation(e, t, n) {
	let r = e.match(n.other.indentCodeCompensation);
	if (r === null) return t;
	let i = r[1];
	return t.split("\n").map((e) => {
		let t = e.match(n.other.beginningSpace);
		if (t === null) return e;
		let [r] = t;
		return r.length >= i.length ? e.slice(i.length) : e;
	}).join("\n");
}
var _Tokenizer = class {
	constructor(e) {
		_defineProperty(this, "options", void 0), _defineProperty(this, "rules", void 0), _defineProperty(this, "lexer", void 0), this.options = e || L;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = t[0].replace(this.rules.other.codeRemoveIndent, "");
			return {
				type: "code",
				raw: t[0],
				codeBlockStyle: "indented",
				text: this.options.pedantic ? e : rtrim(e, "\n")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = indentCodeCompensation(e, t[3] || "", this.rules);
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (this.rules.other.endingHash.test(e)) {
				let t = rtrim(e, "#");
				(this.options.pedantic || !t || this.rules.other.endingSpaceChar.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: t[0],
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: rtrim(t[0], "\n")
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = rtrim(t[0], "\n").split("\n"), n = "", r = "", i = [];
			for (; e.length > 0;) {
				let t = !1, a = [], o;
				for (o = 0; o < e.length; o++) if (this.rules.other.blockquoteStart.test(e[o])) a.push(e[o]), t = !0;
				else if (!t) a.push(e[o]);
				else break;
				e = e.slice(o);
				let s = a.join("\n"), c = s.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
				n = n ? `${n}\n${s}` : s, r = r ? `${r}\n${c}` : c;
				let l = this.lexer.state.top;
				if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
				let u = i.at(-1);
				if (u?.type === "code") break;
				if (u?.type === "blockquote") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.blockquote(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - t.raw.length) + o.raw, r = r.substring(0, r.length - t.text.length) + o.text;
					break;
				} else if (u?.type === "list") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.list(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i.at(-1).raw.length).split("\n");
					continue;
				}
			}
			return {
				type: "blockquote",
				raw: n,
				tokens: i,
				text: r
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = this.rules.other.listItemRegex(n), o = !1;
			for (; e;) {
				let n = !1, r = "", s = "";
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				r = t[0], e = e.substring(r.length);
				let c = t[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (e) => " ".repeat(3 * e.length)), l = e.split("\n", 1)[0], u = !c.trim(), d = 0;
				if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = t[2].search(this.rules.other.nonSpaceChar), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && this.rules.other.blankLine.test(l) && (r += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = this.rules.other.nextBulletRegex(d), n = this.rules.other.hrRegex(d), i = this.rules.other.fencesBeginRegex(d), a = this.rules.other.headingBeginRegex(d), o = this.rules.other.htmlBeginRegex(d);
					for (; e;) {
						let f = e.split("\n", 1)[0], p;
						if (l = f, this.options.pedantic ? (l = l.replace(this.rules.other.listReplaceNesting, "  "), p = l) : p = l.replace(this.rules.other.tabCharGlobal, "    "), i.test(l) || a.test(l) || o.test(l) || t.test(l) || n.test(l)) break;
						if (p.search(this.rules.other.nonSpaceChar) >= d || !l.trim()) s += "\n" + p.slice(d);
						else {
							if (u || c.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
							s += "\n" + l;
						}
						!u && !l.trim() && (u = !0), r += f + "\n", e = e.substring(f.length + 1), c = p.slice(d);
					}
				}
				i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(r) && (o = !0));
				let f = null, p;
				this.options.gfm && (f = this.rules.other.listIsTask.exec(s), f && (p = f[0] !== "[ ] ", s = s.replace(this.rules.other.listReplaceTask, ""))), i.items.push({
					type: "list_item",
					raw: r,
					task: !!f,
					checked: p,
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += r;
			}
			let s = i.items.at(-1);
			if (s) s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd();
			else return;
			i.raw = i.raw.trimEnd();
			for (let e = 0; e < i.items.length; e++) if (this.lexer.state.top = !1, i.items[e].tokens = this.lexer.blockTokens(i.items[e].text, []), !i.loose) {
				let t = i.items[e].tokens.filter((e) => e.type === "space");
				i.loose = t.length > 0 && t.some((e) => this.rules.other.anyLine.test(e.raw));
			}
			if (i.loose) for (let e = 0; e < i.items.length; e++) i.items[e].loose = !0;
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) return {
			type: "html",
			block: !0,
			raw: t[0],
			pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
			text: t[0]
		};
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), n = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: t[0],
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
		let n = splitCells(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [], a = {
			type: "table",
			raw: t[0],
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) this.rules.other.tableAlignRight.test(e) ? a.align.push("right") : this.rules.other.tableAlignCenter.test(e) ? a.align.push("center") : this.rules.other.tableAlignLeft.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e = 0; e < n.length; e++) a.header.push({
				text: n[e],
				tokens: this.lexer.inline(n[e]),
				header: !0,
				align: a.align[e]
			});
			for (let e of i) a.rows.push(splitCells(e, a.header.length).map((e, t) => ({
				text: e,
				tokens: this.lexer.inline(e),
				header: !1,
				align: a.align[t]
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) return {
			type: "heading",
			raw: t[0],
			depth: t[2].charAt(0) === "=" ? 1 : 2,
			text: t[1],
			tokens: this.lexer.inline(t[1])
		};
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: t[1]
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let e = t[2].trim();
			if (!this.options.pedantic && this.rules.other.startAngleBracket.test(e)) {
				if (!this.rules.other.endAngleBracket.test(e)) return;
				let t = rtrim(e.slice(0, -1), "\\");
				if ((e.length - t.length) % 2 == 0) return;
			} else {
				let e = findClosingBracket(t[2], "()");
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let n = t[2], r = "";
			if (this.options.pedantic) {
				let e = this.rules.other.pedanticHrefTitle.exec(n);
				e && (n = e[1], r = e[3]);
			} else r = t[3] ? t[3].slice(1, -1) : "";
			return n = n.trim(), this.rules.other.startAngleBracket.test(n) && (n = this.options.pedantic && !this.rules.other.endAngleBracket.test(e) ? n.slice(1) : n.slice(1, -1)), outputLink(t, {
				href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
				title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer, this.rules);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let e = t[(n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " ").toLowerCase()];
			if (!e) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return outputLink(n, e, n[0], this.lexer, this.rules);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (r && !(r[3] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!(r[1] || r[2]) || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) != null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
				if (a = [...i].length, r[3] || r[4]) {
					o += a;
					continue;
				} else if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
					s += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o + s);
				let t = [...r[0]][0].length, c = e.slice(0, n + r.index + t + a);
				if (Math.min(n, a) % 2) {
					let e = c.slice(1, -1);
					return {
						type: "em",
						raw: c,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = c.slice(2, -2);
				return {
					type: "strong",
					raw: c,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(this.rules.other.newLineCharGlobal, " "), n = this.rules.other.nonSpaceChar.test(e), r = this.rules.other.startingSpaceChar.test(e) && this.rules.other.endingSpaceChar.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e) {
		let t = this.rules.inline.del.exec(e);
		if (t) return {
			type: "del",
			raw: t[0],
			text: t[2],
			tokens: this.lexer.inlineTokens(t[2])
		};
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = t[1], n = "mailto:" + e) : (e = t[1], n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = t[0], n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = t[0], n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e = this.lexer.state.inRawBlock;
			return {
				type: "text",
				raw: t[0],
				text: t[0],
				escaped: e
			};
		}
	}
}, Y = class _Lexer {
	constructor(e) {
		_defineProperty(this, "tokens", void 0), _defineProperty(this, "options", void 0), _defineProperty(this, "state", void 0), _defineProperty(this, "tokenizer", void 0), _defineProperty(this, "inlineQueue", void 0), this.tokens = [], this.tokens.links = Object.create(null), this.options = e || L, this.options.tokenizer = this.options.tokenizer || new _Tokenizer(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			top: !0
		};
		let t = {
			other: z,
			block: q.normal,
			inline: J.normal
		};
		this.options.pedantic ? (t.block = q.pedantic, t.inline = J.pedantic) : this.options.gfm && (t.block = q.gfm, this.options.breaks ? t.inline = J.breaks : t.inline = J.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: q,
			inline: J
		};
	}
	static lex(e, t) {
		return new _Lexer(t).lex(e);
	}
	static lexInline(e, t) {
		return new _Lexer(t).inlineTokens(e);
	}
	lex(e) {
		e = e.replace(z.carriageReturn, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = [], n = !1) {
		for (this.options.pedantic && (e = e.replace(z.tabCharGlobal, "    ").replace(z.spaceLine, "")); e;) {
			let r;
			if (this.options.extensions?.block?.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
			if (r = this.tokenizer.space(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				r.raw.length === 1 && n !== void 0 ? n.raw += "\n" : t.push(r);
				continue;
			}
			if (r = this.tokenizer.code(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += "\n" + r.raw, n.text += "\n" + r.text, this.inlineQueue.at(-1).src = n.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.fences(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.heading(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.hr(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.blockquote(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.list(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.html(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.def(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += "\n" + r.raw, n.text += "\n" + r.raw, this.inlineQueue.at(-1).src = n.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
					href: r.href,
					title: r.title
				});
				continue;
			}
			if (r = this.tokenizer.table(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.lheading(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			let i = e;
			if (this.options.extensions?.startBlock) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startBlock.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (this.state.top && (r = this.tokenizer.paragraph(i))) {
				let a = t.at(-1);
				n && a?.type === "paragraph" ? (a.raw += "\n" + r.raw, a.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = a.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
				continue;
			}
			if (r = this.tokenizer.text(e)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += "\n" + r.raw, n.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = n.text) : t.push(r);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				} else throw Error(t);
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	inlineTokens(e, t = []) {
		let n = e, r = null;
		if (this.tokens.links) {
			let e = Object.keys(this.tokens.links);
			if (e.length > 0) for (; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) != null;) e.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
		}
		for (; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) != null;) n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		for (; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) != null;) n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		let i = !1, a = "";
		for (; e;) {
			i || (a = ""), i = !1;
			let r;
			if (this.options.extensions?.inline?.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
			if (r = this.tokenizer.escape(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.tag(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.link(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.reflink(e, this.tokens.links)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				r.type === "text" && n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.emStrong(e, n, a)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.codespan(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.br(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.del(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.autolink(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (!this.state.inLink && (r = this.tokenizer.url(e))) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			let o = e;
			if (this.options.extensions?.startInline) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startInline.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (o = e.substring(0, t + 1));
			}
			if (r = this.tokenizer.inlineText(o)) {
				e = e.substring(r.raw.length), r.raw.slice(-1) !== "_" && (a = r.raw.slice(-1)), i = !0;
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (e) {
				let t = "Infinite loop on byte: " + e.charCodeAt(0);
				if (this.options.silent) {
					console.error(t);
					break;
				} else throw Error(t);
			}
		}
		return t;
	}
}, _Renderer = class {
	constructor(e) {
		_defineProperty(this, "options", void 0), _defineProperty(this, "parser", void 0), this.options = e || L;
	}
	space(e) {
		return "";
	}
	code({ text: e, lang: t, escaped: n }) {
		let r = (t || "").match(z.notSpaceStart)?.[0], i = e.replace(z.endingNewline, "") + "\n";
		return r ? "<pre><code class=\"language-" + escape(r) + "\">" + (n ? i : escape(i, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? i : escape(i, !0)) + "</code></pre>\n";
	}
	blockquote({ tokens: e }) {
		return `<blockquote>\n${this.parser.parse(e)}</blockquote>\n`;
	}
	html({ text: e }) {
		return e;
	}
	heading({ tokens: e, depth: t }) {
		return `<h${t}>${this.parser.parseInline(e)}</h${t}>\n`;
	}
	hr(e) {
		return "<hr>\n";
	}
	list(e) {
		let t = e.ordered, n = e.start, r = "";
		for (let t = 0; t < e.items.length; t++) {
			let n = e.items[t];
			r += this.listitem(n);
		}
		let i = t ? "ol" : "ul", a = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + i + a + ">\n" + r + "</" + i + ">\n";
	}
	listitem(e) {
		let t = "";
		if (e.task) {
			let n = this.checkbox({ checked: !!e.checked });
			e.loose ? e.tokens[0]?.type === "paragraph" ? (e.tokens[0].text = n + " " + e.tokens[0].text, e.tokens[0].tokens && e.tokens[0].tokens.length > 0 && e.tokens[0].tokens[0].type === "text" && (e.tokens[0].tokens[0].text = n + " " + escape(e.tokens[0].tokens[0].text), e.tokens[0].tokens[0].escaped = !0)) : e.tokens.unshift({
				type: "text",
				raw: n + " ",
				text: n + " ",
				escaped: !0
			}) : t += n + " ";
		}
		return t += this.parser.parse(e.tokens, !!e.loose), `<li>${t}</li>\n`;
	}
	checkbox({ checked: e }) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\">";
	}
	paragraph({ tokens: e }) {
		return `<p>${this.parser.parseInline(e)}</p>\n`;
	}
	table(e) {
		let t = "", n = "";
		for (let t = 0; t < e.header.length; t++) n += this.tablecell(e.header[t]);
		t += this.tablerow({ text: n });
		let r = "";
		for (let t = 0; t < e.rows.length; t++) {
			let i = e.rows[t];
			n = "";
			for (let e = 0; e < i.length; e++) n += this.tablecell(i[e]);
			r += this.tablerow({ text: n });
		}
		return r && (r = `<tbody>${r}</tbody>`), "<table>\n<thead>\n" + t + "</thead>\n" + r + "</table>\n";
	}
	tablerow({ text: e }) {
		return `<tr>\n${e}</tr>\n`;
	}
	tablecell(e) {
		let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
		return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>\n`;
	}
	strong({ tokens: e }) {
		return `<strong>${this.parser.parseInline(e)}</strong>`;
	}
	em({ tokens: e }) {
		return `<em>${this.parser.parseInline(e)}</em>`;
	}
	codespan({ text: e }) {
		return `<code>${escape(e, !0)}</code>`;
	}
	br(e) {
		return "<br>";
	}
	del({ tokens: e }) {
		return `<del>${this.parser.parseInline(e)}</del>`;
	}
	link({ href: e, title: t, tokens: n }) {
		let r = this.parser.parseInline(n), i = cleanUrl(e);
		if (i === null) return r;
		e = i;
		let a = "<a href=\"" + e + "\"";
		return t && (a += " title=\"" + escape(t) + "\""), a += ">" + r + "</a>", a;
	}
	image({ href: e, title: t, text: n }) {
		let r = cleanUrl(e);
		if (r === null) return escape(n);
		e = r;
		let i = `<img src="${e}" alt="${n}"`;
		return t && (i += ` title="${escape(t)}"`), i += ">", i;
	}
	text(e) {
		return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : escape(e.text);
	}
}, _TextRenderer = class {
	strong({ text: e }) {
		return e;
	}
	em({ text: e }) {
		return e;
	}
	codespan({ text: e }) {
		return e;
	}
	del({ text: e }) {
		return e;
	}
	html({ text: e }) {
		return e;
	}
	text({ text: e }) {
		return e;
	}
	link({ text: e }) {
		return "" + e;
	}
	image({ text: e }) {
		return "" + e;
	}
	br() {
		return "";
	}
}, X = class _Parser {
	constructor(e) {
		_defineProperty(this, "options", void 0), _defineProperty(this, "renderer", void 0), _defineProperty(this, "textRenderer", void 0), this.options = e || L, this.options.renderer = this.options.renderer || new _Renderer(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new _TextRenderer();
	}
	static parse(e, t) {
		return new _Parser(t).parse(e);
	}
	static parseInline(e, t) {
		return new _Parser(t).parseInline(e);
	}
	parse(e, t = !0) {
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions?.renderers?.[i.type]) {
				let e = i, t = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (t !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"paragraph",
					"text"
				].includes(e.type)) {
					n += t || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "space":
					n += this.renderer.space(a);
					continue;
				case "hr":
					n += this.renderer.hr(a);
					continue;
				case "heading":
					n += this.renderer.heading(a);
					continue;
				case "code":
					n += this.renderer.code(a);
					continue;
				case "table":
					n += this.renderer.table(a);
					continue;
				case "blockquote":
					n += this.renderer.blockquote(a);
					continue;
				case "list":
					n += this.renderer.list(a);
					continue;
				case "html":
					n += this.renderer.html(a);
					continue;
				case "paragraph":
					n += this.renderer.paragraph(a);
					continue;
				case "text": {
					let i = a, o = this.renderer.text(i);
					for (; r + 1 < e.length && e[r + 1].type === "text";) i = e[++r], o += "\n" + this.renderer.text(i);
					t ? n += this.renderer.paragraph({
						type: "paragraph",
						raw: o,
						text: o,
						tokens: [{
							type: "text",
							raw: o,
							text: o,
							escaped: !0
						}]
					}) : n += o;
					continue;
				}
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
	parseInline(e, t = this.renderer) {
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions?.renderers?.[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "escape":
					n += t.text(a);
					break;
				case "html":
					n += t.html(a);
					break;
				case "link":
					n += t.link(a);
					break;
				case "image":
					n += t.image(a);
					break;
				case "strong":
					n += t.strong(a);
					break;
				case "em":
					n += t.em(a);
					break;
				case "codespan":
					n += t.codespan(a);
					break;
				case "br":
					n += t.br(a);
					break;
				case "del":
					n += t.del(a);
					break;
				case "text":
					n += t.text(a);
					break;
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, _Hooks = class {
	constructor(e) {
		_defineProperty(this, "options", void 0), _defineProperty(this, "block", void 0), this.options = e || L;
	}
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
	provideLexer() {
		return this.block ? Y.lex : Y.lexInline;
	}
	provideParser() {
		return this.block ? X.parse : X.parseInline;
	}
};
_defineProperty(_Hooks, "passThroughHooks", new Set([
	"preprocess",
	"postprocess",
	"processAllTokens"
]));
var Marked = class {
	constructor(...e) {
		_defineProperty(this, "defaults", _getDefaults()), _defineProperty(this, "options", this.setOptions), _defineProperty(this, "parse", this.parseMarkdown(!0)), _defineProperty(this, "parseInline", this.parseMarkdown(!1)), _defineProperty(this, "Parser", X), _defineProperty(this, "Renderer", _Renderer), _defineProperty(this, "TextRenderer", _TextRenderer), _defineProperty(this, "Lexer", Y), _defineProperty(this, "Tokenizer", _Tokenizer), _defineProperty(this, "Hooks", _Hooks), this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new _Renderer(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (["options", "parser"].includes(n)) continue;
					let r = n, i = e.renderer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new _Tokenizer(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new _Hooks();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (["options", "block"].includes(n)) continue;
					let r = n, i = e.hooks[r], a = t[r];
					_Hooks.passThroughHooks.has(n) ? t[r] = (e) => {
						if (this.defaults.async) return Promise.resolve(i.call(t, e)).then((e) => a.call(t, e));
						let n = i.call(t, e);
						return a.call(t, n);
					} : t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return Y.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return X.parse(e, t ?? this.defaults);
	}
	parseMarkdown(e) {
		let parse = (t, n) => {
			let r = { ...n }, i = {
				...this.defaults,
				...r
			}, a = this.onError(!!i.silent, !!i.async);
			if (this.defaults.async === !0 && r.async === !1) return a(/* @__PURE__ */ Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
			if (t == null) return a(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof t != "string") return a(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected"));
			i.hooks && (i.hooks.options = i, i.hooks.block = e);
			let o = i.hooks ? i.hooks.provideLexer() : e ? Y.lex : Y.lexInline, s = i.hooks ? i.hooks.provideParser() : e ? X.parse : X.parseInline;
			if (i.async) return Promise.resolve(i.hooks ? i.hooks.preprocess(t) : t).then((e) => o(e, i)).then((e) => i.hooks ? i.hooks.processAllTokens(e) : e).then((e) => i.walkTokens ? Promise.all(this.walkTokens(e, i.walkTokens)).then(() => e) : e).then((e) => s(e, i)).then((e) => i.hooks ? i.hooks.postprocess(e) : e).catch(a);
			try {
				i.hooks && (t = i.hooks.preprocess(t));
				let e = o(t, i);
				i.hooks && (e = i.hooks.processAllTokens(e)), i.walkTokens && this.walkTokens(e, i.walkTokens);
				let n = s(e, i);
				return i.hooks && (n = i.hooks.postprocess(n)), n;
			} catch (e) {
				return a(e);
			}
		};
		return parse;
	}
	onError(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + escape(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}, Z = new Marked();
function marked(e, t) {
	return Z.parse(e, t);
}
marked.options = marked.setOptions = function(e) {
	return Z.setOptions(e), marked.defaults = Z.defaults, changeDefaults(marked.defaults), marked;
}, marked.getDefaults = _getDefaults, marked.defaults = L, marked.use = function(...e) {
	return Z.use(...e), marked.defaults = Z.defaults, changeDefaults(marked.defaults), marked;
}, marked.walkTokens = function(e, t) {
	return Z.walkTokens(e, t);
}, marked.parseInline = Z.parseInline, marked.Parser = X, marked.parser = X.parse, marked.Renderer = _Renderer, marked.TextRenderer = _TextRenderer, marked.Lexer = Y, marked.lexer = Y.lex, marked.Tokenizer = _Tokenizer, marked.Hooks = _Hooks, marked.parse = marked, marked.options, marked.setOptions, marked.use, marked.walkTokens, marked.parseInline, X.parse;
var lt = Y.lex;
//#endregion
//#region src/components/cardRendering/MarkdownRendererHelpers.ts
function splitByDelimiters(e, t, n) {
	if (e.length === 0) return [];
	let r = [], i = e.indexOf(t), a = e.indexOf(n, i);
	if (i >= 0 && a > i) r.push(e.substring(0, i)), r.push(e.substring(i, a + n.length)), r = r.concat(splitByDelimiters(e.substring(a + n.length), t, n));
	else return [e];
	return r;
}
function stripTrailingNewlines(e) {
	return e.replace(/[\r\n]+$/, "");
}
function splitTextToken(e) {
	if (containsComponent(e)) {
		let t = splitByDelimiters(stripTrailingNewlines(e.text), "{{", "}}"), n = splitByDelimiters(stripTrailingNewlines(e.raw), "{{", "}}");
		if (t.length === n.length) return t.map((e, r) => ({
			type: "text",
			text: t[r],
			raw: n[r]
		}));
		throw Error("Error parsing markdown");
	} else return [e];
}
function splitParagraphToken(e) {
	let t = [];
	if (containsComponent(e)) {
		let n = splitByDelimiters(stripTrailingNewlines(e.text), "{{", "}}"), r = splitByDelimiters(stripTrailingNewlines(e.raw), "{{", "}}");
		if (n.length === r.length) {
			for (let e = 0; e < n.length; e++) {
				let i = {
					type: "text",
					text: n[e],
					raw: r[e]
				};
				isComponent(i) ? t.push(i) : lt(r[e]).forEach((e) => {
					e.type === "paragraph" ? t = t.concat(e.tokens) : t.push(e);
				});
			}
			return t;
		} else throw Error("Error parsing Markdown");
	} else t.push(e);
	return t;
}
function containsComponent(e) {
	if (e.type === "text" || e.type === "paragraph") {
		let t = e.raw.indexOf("{{"), n = e.raw.indexOf("}}");
		return t !== -1 && n !== -1 && n > t;
	} else return !1;
}
function isComponent(e) {
	return e.type === "text" && e.text.startsWith("{{") && e.text.endsWith("}}");
}
function parseComponentSyntax(e) {
	if (e.length > 1e4) return null;
	let t = e.match(/^\{\{\s*<([\w-]+)((?:\s+[\w-]+="[^"]*")*)\s*\/>\s*\}\}$/);
	if (!t) return null;
	let n = t[1], r = t[2], i = {};
	if (r) {
		let e = /\s+([\w-]+)="([^"]*)"/g, t;
		for (; (t = e.exec(r)) !== null;) i[t[1]] = t[2];
	}
	return {
		componentName: n,
		props: i
	};
}
function isInlineComponent(e) {
	if (e.length > 1e4) return !1;
	let t = e.trim();
	return /^<[\w-]+(?:\s+[\w-]+="[^"]*")*\s*\/?>$/.test(t);
}
function parseComponentToken(e) {
	return parseComponentSyntax("text" in e ? e.text : "raw" in e ? e.raw : "");
}
//#endregion
//#region src/components/cardRendering/AudioAutoPlayer.vue?vue&type=script&setup=true&lang.ts
var ut = 500, dt = /* @__PURE__ */ F(/* @__PURE__ */ l({
	__name: "AudioAutoPlayer",
	props: { src: {} },
	setup(e) {
		let t = e, r = y([]), i = y([]), a = y(!1), c = null, stop = () => {
			a.value = !1, setTimeout(() => {
				c = null;
			}, ut), i.value.forEach(clearTimeout), console.log("Audio stopping..."), r.value.forEach((e) => {
				e.paused || (e.pause(), e.currentTime = 0);
			});
		}, downloadFinished = (e) => {
			try {
				return !isNaN(r.value[e].duration);
			} catch (e) {
				throw Error("AudioPlayer does not have an element at this index:", e);
			}
		}, playByIndex = (e) => {
			if (downloadFinished(e)) if (r.value[e].play(), e + 1 < r.value.length) {
				let t = (r.value[e].duration + .7) * 1e3;
				i.value.push(setTimeout(() => {
					a.value && playByIndex(e + 1);
				}, t));
			} else setTimeout(() => {
				a.value = !1;
			}, r.value[e].duration * 1e3), setTimeout(() => {
				c = null;
			}, r.value[e].duration * 1e3 + ut);
			else setTimeout(playByIndex, 100, e);
		}, play = () => {
			c === null || c === u() ? (c = u(), a.value = !0, playByIndex(0)) : setTimeout(play, 100);
		};
		return _(() => {
			c = null, typeof t.src == "string" ? r.value.push(new Audio(t.src)) : t.src.forEach((e) => {
				r.value.push(new Audio(e));
			});
			let e = [{
				hotkey: "up",
				callback: play,
				command: "Replay Audio"
			}];
			I.addBinding(e), play();
		}), g(() => {
			I.removeBinding("up"), stop();
		}), (e, t) => {
			let r = x("v-icon"), i = x("v-btn");
			return v(), n(i, {
				size: "large",
				icon: "",
				color: a.value ? "primary lighten-3" : "primary",
				class: h({ playing: a.value }),
				onClick: play
			}, {
				default: E(() => [s(r, null, {
					default: E(() => t[0] || (t[0] = [o("mdi-volume-high")])),
					_: 1
				})]),
				_: 1
			}, 8, ["color", "class"]);
		};
	}
}), [["__scopeId", "data-v-e1a0f62c"]]), Q = (/* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((e, t) => {
	function deepFreeze(e) {
		return e instanceof Map ? e.clear = e.delete = e.set = function() {
			throw Error("map is read-only");
		} : e instanceof Set && (e.add = e.clear = e.delete = function() {
			throw Error("set is read-only");
		}), Object.freeze(e), Object.getOwnPropertyNames(e).forEach((t) => {
			let n = e[t], r = typeof n;
			(r === "object" || r === "function") && !Object.isFrozen(n) && deepFreeze(n);
		}), e;
	}
	var Response = class {
		constructor(e) {
			e.data === void 0 && (e.data = {}), this.data = e.data, this.isMatchIgnored = !1;
		}
		ignoreMatch() {
			this.isMatchIgnored = !0;
		}
	};
	function escapeHTML(e) {
		return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	}
	function inherit$1(e, ...t) {
		let n = Object.create(null);
		for (let t in e) n[t] = e[t];
		return t.forEach(function(e) {
			for (let t in e) n[t] = e[t];
		}), n;
	}
	var n = "</span>", emitsWrappingTags = (e) => !!e.scope, scopeToCSSClass = (e, { prefix: t }) => {
		if (e.startsWith("language:")) return e.replace("language:", "language-");
		if (e.includes(".")) {
			let n = e.split(".");
			return [`${t}${n.shift()}`, ...n.map((e, t) => `${e}${"_".repeat(t + 1)}`)].join(" ");
		}
		return `${t}${e}`;
	}, HTMLRenderer = class {
		constructor(e, t) {
			this.buffer = "", this.classPrefix = t.classPrefix, e.walk(this);
		}
		addText(e) {
			this.buffer += escapeHTML(e);
		}
		openNode(e) {
			if (!emitsWrappingTags(e)) return;
			let t = scopeToCSSClass(e.scope, { prefix: this.classPrefix });
			this.span(t);
		}
		closeNode(e) {
			emitsWrappingTags(e) && (this.buffer += n);
		}
		value() {
			return this.buffer;
		}
		span(e) {
			this.buffer += `<span class="${e}">`;
		}
	}, newNode = (e = {}) => {
		let t = { children: [] };
		return Object.assign(t, e), t;
	}, r = class TokenTree {
		constructor() {
			this.rootNode = newNode(), this.stack = [this.rootNode];
		}
		get top() {
			return this.stack[this.stack.length - 1];
		}
		get root() {
			return this.rootNode;
		}
		add(e) {
			this.top.children.push(e);
		}
		openNode(e) {
			let t = newNode({ scope: e });
			this.add(t), this.stack.push(t);
		}
		closeNode() {
			if (this.stack.length > 1) return this.stack.pop();
		}
		closeAllNodes() {
			for (; this.closeNode(););
		}
		toJSON() {
			return JSON.stringify(this.rootNode, null, 4);
		}
		walk(e) {
			return this.constructor._walk(e, this.rootNode);
		}
		static _walk(e, t) {
			return typeof t == "string" ? e.addText(t) : t.children && (e.openNode(t), t.children.forEach((t) => this._walk(e, t)), e.closeNode(t)), e;
		}
		static _collapse(e) {
			typeof e != "string" && e.children && (e.children.every((e) => typeof e == "string") ? e.children = [e.children.join("")] : e.children.forEach((e) => {
				TokenTree._collapse(e);
			}));
		}
	}, TokenTreeEmitter = class extends r {
		constructor(e) {
			super(), this.options = e;
		}
		addText(e) {
			e !== "" && this.add(e);
		}
		startScope(e) {
			this.openNode(e);
		}
		endScope() {
			this.closeNode();
		}
		__addSublanguage(e, t) {
			let n = e.root;
			t && (n.scope = `language:${t}`), this.add(n);
		}
		toHTML() {
			return new HTMLRenderer(this, this.options).value();
		}
		finalize() {
			return this.closeAllNodes(), !0;
		}
	};
	function source(e) {
		return e ? typeof e == "string" ? e : e.source : null;
	}
	function lookahead(e) {
		return concat("(?=", e, ")");
	}
	function anyNumberOfTimes(e) {
		return concat("(?:", e, ")*");
	}
	function optional(e) {
		return concat("(?:", e, ")?");
	}
	function concat(...e) {
		return e.map((e) => source(e)).join("");
	}
	function stripOptionsFromArgs(e) {
		let t = e[e.length - 1];
		return typeof t == "object" && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
	}
	function either(...e) {
		return "(" + (stripOptionsFromArgs(e).capture ? "" : "?:") + e.map((e) => source(e)).join("|") + ")";
	}
	function countMatchGroups(e) {
		return RegExp(e.toString() + "|").exec("").length - 1;
	}
	function startsWith(e, t) {
		let n = e && e.exec(t);
		return n && n.index === 0;
	}
	var i = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
	function _rewriteBackreferences(e, { joinWith: t }) {
		let n = 0;
		return e.map((e) => {
			n += 1;
			let t = n, r = source(e), a = "";
			for (; r.length > 0;) {
				let e = i.exec(r);
				if (!e) {
					a += r;
					break;
				}
				a += r.substring(0, e.index), r = r.substring(e.index + e[0].length), e[0][0] === "\\" && e[1] ? a += "\\" + String(Number(e[1]) + t) : (a += e[0], e[0] === "(" && n++);
			}
			return a;
		}).map((e) => `(${e})`).join(t);
	}
	var a = /\b\B/, o = "[a-zA-Z]\\w*", s = "[a-zA-Z_]\\w*", c = "\\b\\d+(\\.\\d+)?", l = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", u = "\\b(0b[01]+)", d = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", SHEBANG = (e = {}) => {
		let t = /^#![ ]*\//;
		return e.binary && (e.begin = concat(t, /.*\b/, e.binary, /\b.*/)), inherit$1({
			scope: "meta",
			begin: t,
			end: /$/,
			relevance: 0,
			"on:begin": (e, t) => {
				e.index !== 0 && t.ignoreMatch();
			}
		}, e);
	}, f = {
		begin: "\\\\[\\s\\S]",
		relevance: 0
	}, p = {
		scope: "string",
		begin: "'",
		end: "'",
		illegal: "\\n",
		contains: [f]
	}, m = {
		scope: "string",
		begin: "\"",
		end: "\"",
		illegal: "\\n",
		contains: [f]
	}, h = { begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/ }, COMMENT = function(e, t, n = {}) {
		let r = inherit$1({
			scope: "comment",
			begin: e,
			end: t,
			contains: []
		}, n);
		r.contains.push({
			scope: "doctag",
			begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
			end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
			excludeBegin: !0,
			relevance: 0
		});
		let i = either("I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/);
		return r.contains.push({ begin: concat(/[ ]+/, "(", i, /[.]?[:]?([.][ ]|[ ])/, "){3}") }), r;
	}, g = COMMENT("//", "$"), _ = COMMENT("/\\*", "\\*/"), v = COMMENT("#", "$"), y = {
		scope: "number",
		begin: c,
		relevance: 0
	}, b = {
		scope: "number",
		begin: l,
		relevance: 0
	}, x = {
		scope: "number",
		begin: u,
		relevance: 0
	}, S = {
		scope: "regexp",
		begin: /\/(?=[^/\n]*\/)/,
		end: /\/[gimuy]*/,
		contains: [f, {
			begin: /\[/,
			end: /\]/,
			relevance: 0,
			contains: [f]
		}]
	}, C = {
		scope: "title",
		begin: o,
		relevance: 0
	}, w = {
		scope: "title",
		begin: s,
		relevance: 0
	}, T = {
		begin: "\\.\\s*" + s,
		relevance: 0
	}, END_SAME_AS_BEGIN = function(e) {
		return Object.assign(e, {
			"on:begin": (e, t) => {
				t.data._beginMatch = e[1];
			},
			"on:end": (e, t) => {
				t.data._beginMatch !== e[1] && t.ignoreMatch();
			}
		});
	}, E = /* @__PURE__ */ Object.freeze({
		__proto__: null,
		APOS_STRING_MODE: p,
		BACKSLASH_ESCAPE: f,
		BINARY_NUMBER_MODE: x,
		BINARY_NUMBER_RE: u,
		COMMENT,
		C_BLOCK_COMMENT_MODE: _,
		C_LINE_COMMENT_MODE: g,
		C_NUMBER_MODE: b,
		C_NUMBER_RE: l,
		END_SAME_AS_BEGIN,
		HASH_COMMENT_MODE: v,
		IDENT_RE: o,
		MATCH_NOTHING_RE: a,
		METHOD_GUARD: T,
		NUMBER_MODE: y,
		NUMBER_RE: c,
		PHRASAL_WORDS_MODE: h,
		QUOTE_STRING_MODE: m,
		REGEXP_MODE: S,
		RE_STARTERS_RE: d,
		SHEBANG,
		TITLE_MODE: C,
		UNDERSCORE_IDENT_RE: s,
		UNDERSCORE_TITLE_MODE: w
	});
	function skipIfHasPrecedingDot(e, t) {
		e.input[e.index - 1] === "." && t.ignoreMatch();
	}
	function scopeClassName(e, t) {
		e.className !== void 0 && (e.scope = e.className, delete e.className);
	}
	function beginKeywords(e, t) {
		t && e.beginKeywords && (e.begin = "\\b(" + e.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", e.__beforeBegin = skipIfHasPrecedingDot, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, e.relevance === void 0 && (e.relevance = 0));
	}
	function compileIllegal(e, t) {
		Array.isArray(e.illegal) && (e.illegal = either(...e.illegal));
	}
	function compileMatch(e, t) {
		if (e.match) {
			if (e.begin || e.end) throw Error("begin & end are not supported with match");
			e.begin = e.match, delete e.match;
		}
	}
	function compileRelevance(e, t) {
		e.relevance === void 0 && (e.relevance = 1);
	}
	var beforeMatchExt = (e, t) => {
		if (!e.beforeMatch) return;
		if (e.starts) throw Error("beforeMatch cannot be used with starts");
		let n = Object.assign({}, e);
		Object.keys(e).forEach((t) => {
			delete e[t];
		}), e.keywords = n.keywords, e.begin = concat(n.beforeMatch, lookahead(n.begin)), e.starts = {
			relevance: 0,
			contains: [Object.assign(n, { endsParent: !0 })]
		}, e.relevance = 0, delete n.beforeMatch;
	}, D = [
		"of",
		"and",
		"for",
		"in",
		"not",
		"or",
		"if",
		"then",
		"parent",
		"list",
		"value"
	], O = "keyword";
	function compileKeywords(e, t, n = O) {
		let r = Object.create(null);
		return typeof e == "string" ? compileList(n, e.split(" ")) : Array.isArray(e) ? compileList(n, e) : Object.keys(e).forEach(function(n) {
			Object.assign(r, compileKeywords(e[n], t, n));
		}), r;
		function compileList(e, n) {
			t && (n = n.map((e) => e.toLowerCase())), n.forEach(function(t) {
				let n = t.split("|");
				r[n[0]] = [e, scoreForKeyword(n[0], n[1])];
			});
		}
	}
	function scoreForKeyword(e, t) {
		return t ? Number(t) : commonKeyword(e) ? 0 : 1;
	}
	function commonKeyword(e) {
		return D.includes(e.toLowerCase());
	}
	var k = {}, error = (e) => {
		console.error(e);
	}, warn = (e, ...t) => {
		console.log(`WARN: ${e}`, ...t);
	}, deprecated = (e, t) => {
		k[`${e}/${t}`] || (console.log(`Deprecated as of ${e}. ${t}`), k[`${e}/${t}`] = !0);
	}, A = /* @__PURE__ */ Error();
	function remapScopeNames(e, t, { key: n }) {
		let r = 0, i = e[n], a = {}, o = {};
		for (let e = 1; e <= t.length; e++) o[e + r] = i[e], a[e + r] = !0, r += countMatchGroups(t[e - 1]);
		e[n] = o, e[n]._emit = a, e[n]._multi = !0;
	}
	function beginMultiClass(e) {
		if (Array.isArray(e.begin)) {
			if (e.skip || e.excludeBegin || e.returnBegin) throw error("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), A;
			if (typeof e.beginScope != "object" || e.beginScope === null) throw error("beginScope must be object"), A;
			remapScopeNames(e, e.begin, { key: "beginScope" }), e.begin = _rewriteBackreferences(e.begin, { joinWith: "" });
		}
	}
	function endMultiClass(e) {
		if (Array.isArray(e.end)) {
			if (e.skip || e.excludeEnd || e.returnEnd) throw error("skip, excludeEnd, returnEnd not compatible with endScope: {}"), A;
			if (typeof e.endScope != "object" || e.endScope === null) throw error("endScope must be object"), A;
			remapScopeNames(e, e.end, { key: "endScope" }), e.end = _rewriteBackreferences(e.end, { joinWith: "" });
		}
	}
	function scopeSugar(e) {
		e.scope && typeof e.scope == "object" && e.scope !== null && (e.beginScope = e.scope, delete e.scope);
	}
	function MultiClass(e) {
		scopeSugar(e), typeof e.beginScope == "string" && (e.beginScope = { _wrap: e.beginScope }), typeof e.endScope == "string" && (e.endScope = { _wrap: e.endScope }), beginMultiClass(e), endMultiClass(e);
	}
	function compileLanguage(e) {
		function langRe(t, n) {
			return new RegExp(source(t), "m" + (e.case_insensitive ? "i" : "") + (e.unicodeRegex ? "u" : "") + (n ? "g" : ""));
		}
		class MultiRegex {
			constructor() {
				this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
			}
			addRule(e, t) {
				t.position = this.position++, this.matchIndexes[this.matchAt] = t, this.regexes.push([t, e]), this.matchAt += countMatchGroups(e) + 1;
			}
			compile() {
				this.regexes.length === 0 && (this.exec = () => null), this.matcherRe = langRe(_rewriteBackreferences(this.regexes.map((e) => e[1]), { joinWith: "|" }), !0), this.lastIndex = 0;
			}
			exec(e) {
				this.matcherRe.lastIndex = this.lastIndex;
				let t = this.matcherRe.exec(e);
				if (!t) return null;
				let n = t.findIndex((e, t) => t > 0 && e !== void 0), r = this.matchIndexes[n];
				return t.splice(0, n), Object.assign(t, r);
			}
		}
		class ResumableMultiRegex {
			constructor() {
				this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
			}
			getMatcher(e) {
				if (this.multiRegexes[e]) return this.multiRegexes[e];
				let t = new MultiRegex();
				return this.rules.slice(e).forEach(([e, n]) => t.addRule(e, n)), t.compile(), this.multiRegexes[e] = t, t;
			}
			resumingScanAtSamePosition() {
				return this.regexIndex !== 0;
			}
			considerAll() {
				this.regexIndex = 0;
			}
			addRule(e, t) {
				this.rules.push([e, t]), t.type === "begin" && this.count++;
			}
			exec(e) {
				let t = this.getMatcher(this.regexIndex);
				t.lastIndex = this.lastIndex;
				let n = t.exec(e);
				if (this.resumingScanAtSamePosition() && !(n && n.index === this.lastIndex)) {
					let t = this.getMatcher(0);
					t.lastIndex = this.lastIndex + 1, n = t.exec(e);
				}
				return n && (this.regexIndex += n.position + 1, this.regexIndex === this.count && this.considerAll()), n;
			}
		}
		function buildModeRegex(e) {
			let t = new ResumableMultiRegex();
			return e.contains.forEach((e) => t.addRule(e.begin, {
				rule: e,
				type: "begin"
			})), e.terminatorEnd && t.addRule(e.terminatorEnd, { type: "end" }), e.illegal && t.addRule(e.illegal, { type: "illegal" }), t;
		}
		function compileMode(t, n) {
			let r = t;
			if (t.isCompiled) return r;
			[
				scopeClassName,
				compileMatch,
				MultiClass,
				beforeMatchExt
			].forEach((e) => e(t, n)), e.compilerExtensions.forEach((e) => e(t, n)), t.__beforeBegin = null, [
				beginKeywords,
				compileIllegal,
				compileRelevance
			].forEach((e) => e(t, n)), t.isCompiled = !0;
			let i = null;
			return typeof t.keywords == "object" && t.keywords.$pattern && (t.keywords = Object.assign({}, t.keywords), i = t.keywords.$pattern, delete t.keywords.$pattern), i = i || /\w+/, t.keywords && (t.keywords = compileKeywords(t.keywords, e.case_insensitive)), r.keywordPatternRe = langRe(i, !0), n && (t.begin || (t.begin = /\B|\b/), r.beginRe = langRe(r.begin), !t.end && !t.endsWithParent && (t.end = /\B|\b/), t.end && (r.endRe = langRe(r.end)), r.terminatorEnd = source(r.end) || "", t.endsWithParent && n.terminatorEnd && (r.terminatorEnd += (t.end ? "|" : "") + n.terminatorEnd)), t.illegal && (r.illegalRe = langRe(t.illegal)), t.contains || (t.contains = []), t.contains = [].concat(...t.contains.map(function(e) {
				return expandOrCloneMode(e === "self" ? t : e);
			})), t.contains.forEach(function(e) {
				compileMode(e, r);
			}), t.starts && compileMode(t.starts, n), r.matcher = buildModeRegex(r), r;
		}
		if (e.compilerExtensions || (e.compilerExtensions = []), e.contains && e.contains.includes("self")) throw Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
		return e.classNameAliases = inherit$1(e.classNameAliases || {}), compileMode(e);
	}
	function dependencyOnParent(e) {
		return e ? e.endsWithParent || dependencyOnParent(e.starts) : !1;
	}
	function expandOrCloneMode(e) {
		return e.variants && !e.cachedVariants && (e.cachedVariants = e.variants.map(function(t) {
			return inherit$1(e, { variants: null }, t);
		})), e.cachedVariants ? e.cachedVariants : dependencyOnParent(e) ? inherit$1(e, { starts: e.starts ? inherit$1(e.starts) : null }) : Object.isFrozen(e) ? inherit$1(e) : e;
	}
	var ee = "11.11.1", HTMLInjectionError = class extends Error {
		constructor(e, t) {
			super(e), this.name = "HTMLInjectionError", this.html = t;
		}
	}, j = escapeHTML, M = inherit$1, N = Symbol("nomatch"), te = 7, HLJS = function(e) {
		let t = Object.create(null), n = Object.create(null), r = [], i = !0, a = "Could not find the language '{}', did you forget to load/include a language module?", o = {
			disableAutodetect: !0,
			name: "Plain text",
			contains: []
		}, s = {
			ignoreUnescapedHTML: !1,
			throwUnescapedHTML: !1,
			noHighlightRe: /^(no-?highlight)$/i,
			languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
			classPrefix: "hljs-",
			cssSelector: "pre code",
			languages: null,
			__emitter: TokenTreeEmitter
		};
		function shouldNotHighlight(e) {
			return s.noHighlightRe.test(e);
		}
		function blockLanguage(e) {
			let t = e.className + " ";
			t += e.parentNode ? e.parentNode.className : "";
			let n = s.languageDetectRe.exec(t);
			if (n) {
				let t = getLanguage(n[1]);
				return t || (warn(a.replace("{}", n[1])), warn("Falling back to no-highlight mode for this block.", e)), t ? n[1] : "no-highlight";
			}
			return t.split(/\s+/).find((e) => shouldNotHighlight(e) || getLanguage(e));
		}
		function highlight(e, t, n) {
			let r = "", i = "";
			typeof t == "object" ? (r = e, n = t.ignoreIllegals, i = t.language) : (deprecated("10.7.0", "highlight(lang, code, ...args) has been deprecated."), deprecated("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277"), i = e, r = t), n === void 0 && (n = !0);
			let a = {
				code: r,
				language: i
			};
			fire("before:highlight", a);
			let o = a.result ? a.result : _highlight(a.language, a.code, n);
			return o.code = a.code, fire("after:highlight", o), o;
		}
		function _highlight(e, n, r, o) {
			let c = Object.create(null);
			function keywordData(e, t) {
				return e.keywords[t];
			}
			function processKeywords() {
				if (!p.keywords) {
					h.addText(g);
					return;
				}
				let e = 0;
				p.keywordPatternRe.lastIndex = 0;
				let t = p.keywordPatternRe.exec(g), n = "";
				for (; t;) {
					n += g.substring(e, t.index);
					let r = u.case_insensitive ? t[0].toLowerCase() : t[0], i = keywordData(p, r);
					if (i) {
						let [e, a] = i;
						if (h.addText(n), n = "", c[r] = (c[r] || 0) + 1, c[r] <= te && (_ += a), e.startsWith("_")) n += t[0];
						else {
							let n = u.classNameAliases[e] || e;
							emitKeyword(t[0], n);
						}
					} else n += t[0];
					e = p.keywordPatternRe.lastIndex, t = p.keywordPatternRe.exec(g);
				}
				n += g.substring(e), h.addText(n);
			}
			function processSubLanguage() {
				if (g === "") return;
				let e = null;
				if (typeof p.subLanguage == "string") {
					if (!t[p.subLanguage]) {
						h.addText(g);
						return;
					}
					e = _highlight(p.subLanguage, g, !0, m[p.subLanguage]), m[p.subLanguage] = e._top;
				} else e = highlightAuto(g, p.subLanguage.length ? p.subLanguage : null);
				p.relevance > 0 && (_ += e.relevance), h.__addSublanguage(e._emitter, e.language);
			}
			function processBuffer() {
				p.subLanguage == null ? processKeywords() : processSubLanguage(), g = "";
			}
			function emitKeyword(e, t) {
				e !== "" && (h.startScope(t), h.addText(e), h.endScope());
			}
			function emitMultiClass(e, t) {
				let n = 1, r = t.length - 1;
				for (; n <= r;) {
					if (!e._emit[n]) {
						n++;
						continue;
					}
					let r = u.classNameAliases[e[n]] || e[n], i = t[n];
					r ? emitKeyword(i, r) : (g = i, processKeywords(), g = ""), n++;
				}
			}
			function startNewMode(e, t) {
				return e.scope && typeof e.scope == "string" && h.openNode(u.classNameAliases[e.scope] || e.scope), e.beginScope && (e.beginScope._wrap ? (emitKeyword(g, u.classNameAliases[e.beginScope._wrap] || e.beginScope._wrap), g = "") : e.beginScope._multi && (emitMultiClass(e.beginScope, t), g = "")), p = Object.create(e, { parent: { value: p } }), p;
			}
			function endOfMode(e, t, n) {
				let r = startsWith(e.endRe, n);
				if (r) {
					if (e["on:end"]) {
						let n = new Response(e);
						e["on:end"](t, n), n.isMatchIgnored && (r = !1);
					}
					if (r) {
						for (; e.endsParent && e.parent;) e = e.parent;
						return e;
					}
				}
				if (e.endsWithParent) return endOfMode(e.parent, t, n);
			}
			function doIgnore(e) {
				return p.matcher.regexIndex === 0 ? (g += e[0], 1) : (b = !0, 0);
			}
			function doBeginMatch(e) {
				let t = e[0], n = e.rule, r = new Response(n), i = [n.__beforeBegin, n["on:begin"]];
				for (let n of i) if (n && (n(e, r), r.isMatchIgnored)) return doIgnore(t);
				return n.skip ? g += t : (n.excludeBegin && (g += t), processBuffer(), !n.returnBegin && !n.excludeBegin && (g = t)), startNewMode(n, e), n.returnBegin ? 0 : t.length;
			}
			function doEndMatch(e) {
				let t = e[0], r = n.substring(e.index), i = endOfMode(p, e, r);
				if (!i) return N;
				let a = p;
				p.endScope && p.endScope._wrap ? (processBuffer(), emitKeyword(t, p.endScope._wrap)) : p.endScope && p.endScope._multi ? (processBuffer(), emitMultiClass(p.endScope, e)) : a.skip ? g += t : (a.returnEnd || a.excludeEnd || (g += t), processBuffer(), a.excludeEnd && (g = t));
				do
					p.scope && h.closeNode(), !p.skip && !p.subLanguage && (_ += p.relevance), p = p.parent;
				while (p !== i.parent);
				return i.starts && startNewMode(i.starts, e), a.returnEnd ? 0 : t.length;
			}
			function processContinuations() {
				let e = [];
				for (let t = p; t !== u; t = t.parent) t.scope && e.unshift(t.scope);
				e.forEach((e) => h.openNode(e));
			}
			let l = {};
			function processLexeme(t, a) {
				let o = a && a[0];
				if (g += t, o == null) return processBuffer(), 0;
				if (l.type === "begin" && a.type === "end" && l.index === a.index && o === "") {
					if (g += n.slice(a.index, a.index + 1), !i) {
						let t = /* @__PURE__ */ Error(`0 width match regex (${e})`);
						throw t.languageName = e, t.badRule = l.rule, t;
					}
					return 1;
				}
				if (l = a, a.type === "begin") return doBeginMatch(a);
				if (a.type === "illegal" && !r) {
					let e = /* @__PURE__ */ Error("Illegal lexeme \"" + o + "\" for mode \"" + (p.scope || "<unnamed>") + "\"");
					throw e.mode = p, e;
				} else if (a.type === "end") {
					let e = doEndMatch(a);
					if (e !== N) return e;
				}
				if (a.type === "illegal" && o === "") return g += "\n", 1;
				if (y > 1e5 && y > a.index * 3) throw /* @__PURE__ */ Error("potential infinite loop, way more iterations than matches");
				return g += o, o.length;
			}
			let u = getLanguage(e);
			if (!u) throw error(a.replace("{}", e)), Error("Unknown language: \"" + e + "\"");
			let d = compileLanguage(u), f = "", p = o || d, m = {}, h = new s.__emitter(s);
			processContinuations();
			let g = "", _ = 0, v = 0, y = 0, b = !1;
			try {
				if (u.__emitTokens) u.__emitTokens(n, h);
				else {
					for (p.matcher.considerAll();;) {
						y++, b ? b = !1 : p.matcher.considerAll(), p.matcher.lastIndex = v;
						let e = p.matcher.exec(n);
						if (!e) break;
						let t = processLexeme(n.substring(v, e.index), e);
						v = e.index + t;
					}
					processLexeme(n.substring(v));
				}
				return h.finalize(), f = h.toHTML(), {
					language: e,
					value: f,
					relevance: _,
					illegal: !1,
					_emitter: h,
					_top: p
				};
			} catch (t) {
				if (t.message && t.message.includes("Illegal")) return {
					language: e,
					value: j(n),
					illegal: !0,
					relevance: 0,
					_illegalBy: {
						message: t.message,
						index: v,
						context: n.slice(v - 100, v + 100),
						mode: t.mode,
						resultSoFar: f
					},
					_emitter: h
				};
				if (i) return {
					language: e,
					value: j(n),
					illegal: !1,
					relevance: 0,
					errorRaised: t,
					_emitter: h,
					_top: p
				};
				throw t;
			}
		}
		function justTextHighlightResult(e) {
			let t = {
				value: j(e),
				illegal: !1,
				relevance: 0,
				_top: o,
				_emitter: new s.__emitter(s)
			};
			return t._emitter.addText(e), t;
		}
		function highlightAuto(e, n) {
			n = n || s.languages || Object.keys(t);
			let r = justTextHighlightResult(e), i = n.filter(getLanguage).filter(autoDetection).map((t) => _highlight(t, e, !1));
			i.unshift(r);
			let [a, o] = i.sort((e, t) => {
				if (e.relevance !== t.relevance) return t.relevance - e.relevance;
				if (e.language && t.language) {
					if (getLanguage(e.language).supersetOf === t.language) return 1;
					if (getLanguage(t.language).supersetOf === e.language) return -1;
				}
				return 0;
			}), c = a;
			return c.secondBest = o, c;
		}
		function updateClassName(e, t, r) {
			let i = t && n[t] || r;
			e.classList.add("hljs"), e.classList.add(`language-${i}`);
		}
		function highlightElement(e) {
			let t = null, n = blockLanguage(e);
			if (shouldNotHighlight(n)) return;
			if (fire("before:highlightElement", {
				el: e,
				language: n
			}), e.dataset.highlighted) {
				console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", e);
				return;
			}
			if (e.children.length > 0 && (s.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(e)), s.throwUnescapedHTML)) throw new HTMLInjectionError("One of your code blocks includes unescaped HTML.", e.innerHTML);
			t = e;
			let r = t.textContent, i = n ? highlight(r, {
				language: n,
				ignoreIllegals: !0
			}) : highlightAuto(r);
			e.innerHTML = i.value, e.dataset.highlighted = "yes", updateClassName(e, n, i.language), e.result = {
				language: i.language,
				re: i.relevance,
				relevance: i.relevance
			}, i.secondBest && (e.secondBest = {
				language: i.secondBest.language,
				relevance: i.secondBest.relevance
			}), fire("after:highlightElement", {
				el: e,
				result: i,
				text: r
			});
		}
		function configure(e) {
			s = M(s, e);
		}
		let initHighlighting = () => {
			highlightAll(), deprecated("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
		};
		function initHighlightingOnLoad() {
			highlightAll(), deprecated("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
		}
		let c = !1;
		function highlightAll() {
			function boot() {
				highlightAll();
			}
			if (document.readyState === "loading") {
				c || window.addEventListener("DOMContentLoaded", boot, !1), c = !0;
				return;
			}
			document.querySelectorAll(s.cssSelector).forEach(highlightElement);
		}
		function registerLanguage(n, r) {
			let a = null;
			try {
				a = r(e);
			} catch (e) {
				if (error("Language definition for '{}' could not be registered.".replace("{}", n)), i) error(e);
				else throw e;
				a = o;
			}
			a.name || (a.name = n), t[n] = a, a.rawDefinition = r.bind(null, e), a.aliases && registerAliases(a.aliases, { languageName: n });
		}
		function unregisterLanguage(e) {
			delete t[e];
			for (let t of Object.keys(n)) n[t] === e && delete n[t];
		}
		function listLanguages() {
			return Object.keys(t);
		}
		function getLanguage(e) {
			return e = (e || "").toLowerCase(), t[e] || t[n[e]];
		}
		function registerAliases(e, { languageName: t }) {
			typeof e == "string" && (e = [e]), e.forEach((e) => {
				n[e.toLowerCase()] = t;
			});
		}
		function autoDetection(e) {
			let t = getLanguage(e);
			return t && !t.disableAutodetect;
		}
		function upgradePluginAPI(e) {
			e["before:highlightBlock"] && !e["before:highlightElement"] && (e["before:highlightElement"] = (t) => {
				e["before:highlightBlock"](Object.assign({ block: t.el }, t));
			}), e["after:highlightBlock"] && !e["after:highlightElement"] && (e["after:highlightElement"] = (t) => {
				e["after:highlightBlock"](Object.assign({ block: t.el }, t));
			});
		}
		function addPlugin(e) {
			upgradePluginAPI(e), r.push(e);
		}
		function removePlugin(e) {
			let t = r.indexOf(e);
			t !== -1 && r.splice(t, 1);
		}
		function fire(e, t) {
			let n = e;
			r.forEach(function(e) {
				e[n] && e[n](t);
			});
		}
		function deprecateHighlightBlock(e) {
			return deprecated("10.7.0", "highlightBlock will be removed entirely in v12.0"), deprecated("10.7.0", "Please use highlightElement now."), highlightElement(e);
		}
		Object.assign(e, {
			highlight,
			highlightAuto,
			highlightAll,
			highlightElement,
			highlightBlock: deprecateHighlightBlock,
			configure,
			initHighlighting,
			initHighlightingOnLoad,
			registerLanguage,
			unregisterLanguage,
			listLanguages,
			getLanguage,
			registerAliases,
			autoDetection,
			inherit: M,
			addPlugin,
			removePlugin
		}), e.debugMode = function() {
			i = !1;
		}, e.safeMode = function() {
			i = !0;
		}, e.versionString = ee, e.regex = {
			concat,
			lookahead,
			either,
			optional,
			anyNumberOfTimes
		};
		for (let e in E) typeof E[e] == "object" && deepFreeze(E[e]);
		return Object.assign(e, E), e;
	}, P = HLJS({});
	P.newInstance = () => HLJS({}), t.exports = P, P.HighlightJS = P, P.default = P;
})))())).default, ft = l({
	props: {
		code: {
			type: String,
			required: !0
		},
		language: {
			type: String,
			default: ""
		},
		autodetect: {
			type: Boolean,
			default: !0
		},
		ignoreIllegals: {
			type: Boolean,
			default: !0
		}
	},
	setup: function(e) {
		var n = y(e.language);
		T((function() {
			return e.language;
		}), (function(e) {
			n.value = e;
		}));
		var r = t((function() {
			return e.autodetect || !n.value;
		})), i = t((function() {
			return !r.value && !Q.getLanguage(n.value);
		}));
		return {
			className: t((function() {
				return i.value ? "" : "hljs " + n.value;
			})),
			highlightedCode: t((function() {
				if (i.value) return console.warn("The language \"" + n.value + "\" you specified could not be found."), e.code.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
				if (r.value) {
					var t = Q.highlightAuto(e.code);
					return n.value = t.language ?? "", t.value;
				}
				return (t = Q.highlight(e.code, {
					language: n.value,
					ignoreIllegals: e.ignoreIllegals
				})).value;
			}))
		};
	},
	render: function() {
		return d("pre", {}, [d("code", {
			class: this.className,
			innerHTML: this.highlightedCode,
			tabindex: "0"
		})]);
	}
}), pt = {
	install: function(e) {
		e.component("highlightjs", ft);
	},
	component: ft
}, mt = "[A-Za-z$_][0-9A-Za-z$_]*", ht = /* @__PURE__ */ "as.in.of.if.for.while.finally.var.new.function.do.return.void.else.break.catch.instanceof.with.throw.case.default.try.switch.continue.typeof.delete.let.yield.const.class.debugger.async.await.static.import.from.export.extends.using".split("."), gt = [
	"true",
	"false",
	"null",
	"undefined",
	"NaN",
	"Infinity"
], _t = /* @__PURE__ */ "Object.Function.Boolean.Symbol.Math.Date.Number.BigInt.String.RegExp.Array.Float32Array.Float64Array.Int8Array.Uint8Array.Uint8ClampedArray.Int16Array.Int32Array.Uint16Array.Uint32Array.BigInt64Array.BigUint64Array.Set.Map.WeakSet.WeakMap.ArrayBuffer.SharedArrayBuffer.Atomics.DataView.JSON.Promise.Generator.GeneratorFunction.AsyncFunction.Reflect.Proxy.Intl.WebAssembly".split("."), vt = [
	"Error",
	"EvalError",
	"InternalError",
	"RangeError",
	"ReferenceError",
	"SyntaxError",
	"TypeError",
	"URIError"
], yt = [
	"setInterval",
	"setTimeout",
	"clearInterval",
	"clearTimeout",
	"require",
	"exports",
	"eval",
	"isFinite",
	"isNaN",
	"parseFloat",
	"parseInt",
	"decodeURI",
	"decodeURIComponent",
	"encodeURI",
	"encodeURIComponent",
	"escape",
	"unescape"
], bt = [
	"arguments",
	"this",
	"super",
	"console",
	"window",
	"document",
	"localStorage",
	"sessionStorage",
	"module",
	"global"
], xt = [].concat(yt, _t, vt);
function javascript$1(e) {
	let t = e.regex, hasClosingTag = (e, { after: t }) => {
		let n = "</" + e[0].slice(1);
		return e.input.indexOf(n, t) !== -1;
	}, n = mt, r = {
		begin: "<>",
		end: "</>"
	}, i = /<[A-Za-z0-9\\._:-]+\s*\/>/, a = {
		begin: /<[A-Za-z0-9\\._:-]+/,
		end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
		isTrulyOpeningTag: (e, t) => {
			let n = e[0].length + e.index, r = e.input[n];
			if (r === "<" || r === ",") {
				t.ignoreMatch();
				return;
			}
			r === ">" && (hasClosingTag(e, { after: n }) || t.ignoreMatch());
			let i, a = e.input.substring(n);
			if (i = a.match(/^\s*=/)) {
				t.ignoreMatch();
				return;
			}
			if ((i = a.match(/^\s+extends\s+/)) && i.index === 0) {
				t.ignoreMatch();
				return;
			}
		}
	}, o = {
		$pattern: mt,
		keyword: ht,
		literal: gt,
		built_in: xt,
		"variable.language": bt
	}, s = "[0-9](_?[0-9])*", c = `\\.(${s})`, l = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", u = {
		className: "number",
		variants: [
			{ begin: `(\\b(${l})((${c})|\\.)?|(${c}))[eE][+-]?(${s})\\b` },
			{ begin: `\\b(${l})\\b((${c})\\b|\\.)?|(${c})\\b` },
			{ begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
			{ begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
			{ begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
			{ begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
			{ begin: "\\b0[0-7]+n?\\b" }
		],
		relevance: 0
	}, d = {
		className: "subst",
		begin: "\\$\\{",
		end: "\\}",
		keywords: o,
		contains: []
	}, f = {
		begin: ".?html`",
		end: "",
		starts: {
			end: "`",
			returnEnd: !1,
			contains: [e.BACKSLASH_ESCAPE, d],
			subLanguage: "xml"
		}
	}, p = {
		begin: ".?css`",
		end: "",
		starts: {
			end: "`",
			returnEnd: !1,
			contains: [e.BACKSLASH_ESCAPE, d],
			subLanguage: "css"
		}
	}, m = {
		begin: ".?gql`",
		end: "",
		starts: {
			end: "`",
			returnEnd: !1,
			contains: [e.BACKSLASH_ESCAPE, d],
			subLanguage: "graphql"
		}
	}, h = {
		className: "string",
		begin: "`",
		end: "`",
		contains: [e.BACKSLASH_ESCAPE, d]
	}, g = {
		className: "comment",
		variants: [
			e.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
				relevance: 0,
				contains: [{
					begin: "(?=@[A-Za-z]+)",
					relevance: 0,
					contains: [
						{
							className: "doctag",
							begin: "@[A-Za-z]+"
						},
						{
							className: "type",
							begin: "\\{",
							end: "\\}",
							excludeEnd: !0,
							excludeBegin: !0,
							relevance: 0
						},
						{
							className: "variable",
							begin: n + "(?=\\s*(-)|$)",
							endsParent: !0,
							relevance: 0
						},
						{
							begin: /(?=[^\n])\s/,
							relevance: 0
						}
					]
				}]
			}),
			e.C_BLOCK_COMMENT_MODE,
			e.C_LINE_COMMENT_MODE
		]
	}, _ = [
		e.APOS_STRING_MODE,
		e.QUOTE_STRING_MODE,
		f,
		p,
		m,
		h,
		{ match: /\$\d+/ },
		u
	];
	d.contains = _.concat({
		begin: /\{/,
		end: /\}/,
		keywords: o,
		contains: ["self"].concat(_)
	});
	let v = [].concat(g, d.contains), y = v.concat([{
		begin: /(\s*)\(/,
		end: /\)/,
		keywords: o,
		contains: ["self"].concat(v)
	}]), b = {
		className: "params",
		begin: /(\s*)\(/,
		end: /\)/,
		excludeBegin: !0,
		excludeEnd: !0,
		keywords: o,
		contains: y
	}, x = { variants: [{
		match: [
			/class/,
			/\s+/,
			n,
			/\s+/,
			/extends/,
			/\s+/,
			t.concat(n, "(", t.concat(/\./, n), ")*")
		],
		scope: {
			1: "keyword",
			3: "title.class",
			5: "keyword",
			7: "title.class.inherited"
		}
	}, {
		match: [
			/class/,
			/\s+/,
			n
		],
		scope: {
			1: "keyword",
			3: "title.class"
		}
	}] }, S = {
		relevance: 0,
		match: t.either(/\bJSON/, /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
		className: "title.class",
		keywords: { _: [..._t, ...vt] }
	}, C = {
		label: "use_strict",
		className: "meta",
		relevance: 10,
		begin: /^\s*['"]use (strict|asm)['"]/
	}, w = {
		variants: [{ match: [
			/function/,
			/\s+/,
			n,
			/(?=\s*\()/
		] }, { match: [/function/, /\s*(?=\()/] }],
		className: {
			1: "keyword",
			3: "title.function"
		},
		label: "func.def",
		contains: [b],
		illegal: /%/
	}, T = {
		relevance: 0,
		match: /\b[A-Z][A-Z_0-9]+\b/,
		className: "variable.constant"
	};
	function noneOf(e) {
		return t.concat("(?!", e.join("|"), ")");
	}
	let E = {
		match: t.concat(/\b/, noneOf([
			...yt,
			"super",
			"import"
		].map((e) => `${e}\\s*\\(`)), n, t.lookahead(/\s*\(/)),
		className: "title.function",
		relevance: 0
	}, D = {
		begin: t.concat(/\./, t.lookahead(t.concat(n, /(?![0-9A-Za-z$_(])/))),
		end: n,
		excludeBegin: !0,
		keywords: "prototype",
		className: "property",
		relevance: 0
	}, O = {
		match: [
			/get|set/,
			/\s+/,
			n,
			/(?=\()/
		],
		className: {
			1: "keyword",
			3: "title.function"
		},
		contains: [{ begin: /\(\)/ }, b]
	}, k = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + e.UNDERSCORE_IDENT_RE + ")\\s*=>", A = {
		match: [
			/const|var|let/,
			/\s+/,
			n,
			/\s*/,
			/=\s*/,
			/(async\s*)?/,
			t.lookahead(k)
		],
		keywords: "async",
		className: {
			1: "keyword",
			3: "title.function"
		},
		contains: [b]
	};
	return {
		name: "JavaScript",
		aliases: [
			"js",
			"jsx",
			"mjs",
			"cjs"
		],
		keywords: o,
		exports: {
			PARAMS_CONTAINS: y,
			CLASS_REFERENCE: S
		},
		illegal: /#(?![$_A-z])/,
		contains: [
			e.SHEBANG({
				label: "shebang",
				binary: "node",
				relevance: 5
			}),
			C,
			e.APOS_STRING_MODE,
			e.QUOTE_STRING_MODE,
			f,
			p,
			m,
			h,
			g,
			{ match: /\$\d+/ },
			u,
			S,
			{
				scope: "attr",
				match: n + t.lookahead(":"),
				relevance: 0
			},
			A,
			{
				begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
				keywords: "return throw case",
				relevance: 0,
				contains: [
					g,
					e.REGEXP_MODE,
					{
						className: "function",
						begin: k,
						returnBegin: !0,
						end: "\\s*=>",
						contains: [{
							className: "params",
							variants: [
								{
									begin: e.UNDERSCORE_IDENT_RE,
									relevance: 0
								},
								{
									className: null,
									begin: /\(\s*\)/,
									skip: !0
								},
								{
									begin: /(\s*)\(/,
									end: /\)/,
									excludeBegin: !0,
									excludeEnd: !0,
									keywords: o,
									contains: y
								}
							]
						}]
					},
					{
						begin: /,/,
						relevance: 0
					},
					{
						match: /\s+/,
						relevance: 0
					},
					{
						variants: [
							{
								begin: r.begin,
								end: r.end
							},
							{ match: i },
							{
								begin: a.begin,
								"on:begin": a.isTrulyOpeningTag,
								end: a.end
							}
						],
						subLanguage: "xml",
						contains: [{
							begin: a.begin,
							end: a.end,
							skip: !0,
							contains: ["self"]
						}]
					}
				]
			},
			w,
			{ beginKeywords: "while if switch catch for" },
			{
				begin: "\\b(?!function)" + e.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
				returnBegin: !0,
				label: "func.def",
				contains: [b, e.inherit(e.TITLE_MODE, {
					begin: n,
					className: "title.function"
				})]
			},
			{
				match: /\.\.\./,
				relevance: 0
			},
			D,
			{
				match: "\\$" + n,
				relevance: 0
			},
			{
				match: [/\bconstructor(?=\s*\()/],
				className: { 1: "title.function" },
				contains: [b]
			},
			E,
			T,
			x,
			O,
			{ match: /\$[(.]/ }
		]
	};
}
__name(javascript$1, "javascript");
//#endregion
//#region ../../node_modules/highlight.js/es/languages/typescript.js
var $ = "[A-Za-z$_][0-9A-Za-z$_]*", St = /* @__PURE__ */ "as.in.of.if.for.while.finally.var.new.function.do.return.void.else.break.catch.instanceof.with.throw.case.default.try.switch.continue.typeof.delete.let.yield.const.class.debugger.async.await.static.import.from.export.extends.using".split("."), Ct = [
	"true",
	"false",
	"null",
	"undefined",
	"NaN",
	"Infinity"
], wt = /* @__PURE__ */ "Object.Function.Boolean.Symbol.Math.Date.Number.BigInt.String.RegExp.Array.Float32Array.Float64Array.Int8Array.Uint8Array.Uint8ClampedArray.Int16Array.Int32Array.Uint16Array.Uint32Array.BigInt64Array.BigUint64Array.Set.Map.WeakSet.WeakMap.ArrayBuffer.SharedArrayBuffer.Atomics.DataView.JSON.Promise.Generator.GeneratorFunction.AsyncFunction.Reflect.Proxy.Intl.WebAssembly".split("."), Tt = [
	"Error",
	"EvalError",
	"InternalError",
	"RangeError",
	"ReferenceError",
	"SyntaxError",
	"TypeError",
	"URIError"
], Et = [
	"setInterval",
	"setTimeout",
	"clearInterval",
	"clearTimeout",
	"require",
	"exports",
	"eval",
	"isFinite",
	"isNaN",
	"parseFloat",
	"parseInt",
	"decodeURI",
	"decodeURIComponent",
	"encodeURI",
	"encodeURIComponent",
	"escape",
	"unescape"
], Dt = [
	"arguments",
	"this",
	"super",
	"console",
	"window",
	"document",
	"localStorage",
	"sessionStorage",
	"module",
	"global"
], Ot = [].concat(Et, wt, Tt);
function javascript(e) {
	let t = e.regex, hasClosingTag = (e, { after: t }) => {
		let n = "</" + e[0].slice(1);
		return e.input.indexOf(n, t) !== -1;
	}, n = $, r = {
		begin: "<>",
		end: "</>"
	}, i = /<[A-Za-z0-9\\._:-]+\s*\/>/, a = {
		begin: /<[A-Za-z0-9\\._:-]+/,
		end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
		isTrulyOpeningTag: (e, t) => {
			let n = e[0].length + e.index, r = e.input[n];
			if (r === "<" || r === ",") {
				t.ignoreMatch();
				return;
			}
			r === ">" && (hasClosingTag(e, { after: n }) || t.ignoreMatch());
			let i, a = e.input.substring(n);
			if (i = a.match(/^\s*=/)) {
				t.ignoreMatch();
				return;
			}
			if ((i = a.match(/^\s+extends\s+/)) && i.index === 0) {
				t.ignoreMatch();
				return;
			}
		}
	}, o = {
		$pattern: $,
		keyword: St,
		literal: Ct,
		built_in: Ot,
		"variable.language": Dt
	}, s = "[0-9](_?[0-9])*", c = `\\.(${s})`, l = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", u = {
		className: "number",
		variants: [
			{ begin: `(\\b(${l})((${c})|\\.)?|(${c}))[eE][+-]?(${s})\\b` },
			{ begin: `\\b(${l})\\b((${c})\\b|\\.)?|(${c})\\b` },
			{ begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
			{ begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
			{ begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
			{ begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
			{ begin: "\\b0[0-7]+n?\\b" }
		],
		relevance: 0
	}, d = {
		className: "subst",
		begin: "\\$\\{",
		end: "\\}",
		keywords: o,
		contains: []
	}, f = {
		begin: ".?html`",
		end: "",
		starts: {
			end: "`",
			returnEnd: !1,
			contains: [e.BACKSLASH_ESCAPE, d],
			subLanguage: "xml"
		}
	}, p = {
		begin: ".?css`",
		end: "",
		starts: {
			end: "`",
			returnEnd: !1,
			contains: [e.BACKSLASH_ESCAPE, d],
			subLanguage: "css"
		}
	}, m = {
		begin: ".?gql`",
		end: "",
		starts: {
			end: "`",
			returnEnd: !1,
			contains: [e.BACKSLASH_ESCAPE, d],
			subLanguage: "graphql"
		}
	}, h = {
		className: "string",
		begin: "`",
		end: "`",
		contains: [e.BACKSLASH_ESCAPE, d]
	}, g = {
		className: "comment",
		variants: [
			e.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
				relevance: 0,
				contains: [{
					begin: "(?=@[A-Za-z]+)",
					relevance: 0,
					contains: [
						{
							className: "doctag",
							begin: "@[A-Za-z]+"
						},
						{
							className: "type",
							begin: "\\{",
							end: "\\}",
							excludeEnd: !0,
							excludeBegin: !0,
							relevance: 0
						},
						{
							className: "variable",
							begin: n + "(?=\\s*(-)|$)",
							endsParent: !0,
							relevance: 0
						},
						{
							begin: /(?=[^\n])\s/,
							relevance: 0
						}
					]
				}]
			}),
			e.C_BLOCK_COMMENT_MODE,
			e.C_LINE_COMMENT_MODE
		]
	}, _ = [
		e.APOS_STRING_MODE,
		e.QUOTE_STRING_MODE,
		f,
		p,
		m,
		h,
		{ match: /\$\d+/ },
		u
	];
	d.contains = _.concat({
		begin: /\{/,
		end: /\}/,
		keywords: o,
		contains: ["self"].concat(_)
	});
	let v = [].concat(g, d.contains), y = v.concat([{
		begin: /(\s*)\(/,
		end: /\)/,
		keywords: o,
		contains: ["self"].concat(v)
	}]), b = {
		className: "params",
		begin: /(\s*)\(/,
		end: /\)/,
		excludeBegin: !0,
		excludeEnd: !0,
		keywords: o,
		contains: y
	}, x = { variants: [{
		match: [
			/class/,
			/\s+/,
			n,
			/\s+/,
			/extends/,
			/\s+/,
			t.concat(n, "(", t.concat(/\./, n), ")*")
		],
		scope: {
			1: "keyword",
			3: "title.class",
			5: "keyword",
			7: "title.class.inherited"
		}
	}, {
		match: [
			/class/,
			/\s+/,
			n
		],
		scope: {
			1: "keyword",
			3: "title.class"
		}
	}] }, S = {
		relevance: 0,
		match: t.either(/\bJSON/, /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
		className: "title.class",
		keywords: { _: [...wt, ...Tt] }
	}, C = {
		label: "use_strict",
		className: "meta",
		relevance: 10,
		begin: /^\s*['"]use (strict|asm)['"]/
	}, w = {
		variants: [{ match: [
			/function/,
			/\s+/,
			n,
			/(?=\s*\()/
		] }, { match: [/function/, /\s*(?=\()/] }],
		className: {
			1: "keyword",
			3: "title.function"
		},
		label: "func.def",
		contains: [b],
		illegal: /%/
	}, T = {
		relevance: 0,
		match: /\b[A-Z][A-Z_0-9]+\b/,
		className: "variable.constant"
	};
	function noneOf(e) {
		return t.concat("(?!", e.join("|"), ")");
	}
	let E = {
		match: t.concat(/\b/, noneOf([
			...Et,
			"super",
			"import"
		].map((e) => `${e}\\s*\\(`)), n, t.lookahead(/\s*\(/)),
		className: "title.function",
		relevance: 0
	}, D = {
		begin: t.concat(/\./, t.lookahead(t.concat(n, /(?![0-9A-Za-z$_(])/))),
		end: n,
		excludeBegin: !0,
		keywords: "prototype",
		className: "property",
		relevance: 0
	}, O = {
		match: [
			/get|set/,
			/\s+/,
			n,
			/(?=\()/
		],
		className: {
			1: "keyword",
			3: "title.function"
		},
		contains: [{ begin: /\(\)/ }, b]
	}, k = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + e.UNDERSCORE_IDENT_RE + ")\\s*=>", A = {
		match: [
			/const|var|let/,
			/\s+/,
			n,
			/\s*/,
			/=\s*/,
			/(async\s*)?/,
			t.lookahead(k)
		],
		keywords: "async",
		className: {
			1: "keyword",
			3: "title.function"
		},
		contains: [b]
	};
	return {
		name: "JavaScript",
		aliases: [
			"js",
			"jsx",
			"mjs",
			"cjs"
		],
		keywords: o,
		exports: {
			PARAMS_CONTAINS: y,
			CLASS_REFERENCE: S
		},
		illegal: /#(?![$_A-z])/,
		contains: [
			e.SHEBANG({
				label: "shebang",
				binary: "node",
				relevance: 5
			}),
			C,
			e.APOS_STRING_MODE,
			e.QUOTE_STRING_MODE,
			f,
			p,
			m,
			h,
			g,
			{ match: /\$\d+/ },
			u,
			S,
			{
				scope: "attr",
				match: n + t.lookahead(":"),
				relevance: 0
			},
			A,
			{
				begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
				keywords: "return throw case",
				relevance: 0,
				contains: [
					g,
					e.REGEXP_MODE,
					{
						className: "function",
						begin: k,
						returnBegin: !0,
						end: "\\s*=>",
						contains: [{
							className: "params",
							variants: [
								{
									begin: e.UNDERSCORE_IDENT_RE,
									relevance: 0
								},
								{
									className: null,
									begin: /\(\s*\)/,
									skip: !0
								},
								{
									begin: /(\s*)\(/,
									end: /\)/,
									excludeBegin: !0,
									excludeEnd: !0,
									keywords: o,
									contains: y
								}
							]
						}]
					},
					{
						begin: /,/,
						relevance: 0
					},
					{
						match: /\s+/,
						relevance: 0
					},
					{
						variants: [
							{
								begin: r.begin,
								end: r.end
							},
							{ match: i },
							{
								begin: a.begin,
								"on:begin": a.isTrulyOpeningTag,
								end: a.end
							}
						],
						subLanguage: "xml",
						contains: [{
							begin: a.begin,
							end: a.end,
							skip: !0,
							contains: ["self"]
						}]
					}
				]
			},
			w,
			{ beginKeywords: "while if switch catch for" },
			{
				begin: "\\b(?!function)" + e.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
				returnBegin: !0,
				label: "func.def",
				contains: [b, e.inherit(e.TITLE_MODE, {
					begin: n,
					className: "title.function"
				})]
			},
			{
				match: /\.\.\./,
				relevance: 0
			},
			D,
			{
				match: "\\$" + n,
				relevance: 0
			},
			{
				match: [/\bconstructor(?=\s*\()/],
				className: { 1: "title.function" },
				contains: [b]
			},
			E,
			T,
			x,
			O,
			{ match: /\$[(.]/ }
		]
	};
}
function typescript(e) {
	let t = e.regex, n = javascript(e), r = $, i = [
		"any",
		"void",
		"number",
		"boolean",
		"string",
		"object",
		"never",
		"symbol",
		"bigint",
		"unknown"
	], a = {
		begin: [
			/namespace/,
			/\s+/,
			e.IDENT_RE
		],
		beginScope: {
			1: "keyword",
			3: "title.class"
		}
	}, o = {
		beginKeywords: "interface",
		end: /\{/,
		excludeEnd: !0,
		keywords: {
			keyword: "interface extends",
			built_in: i
		},
		contains: [n.exports.CLASS_REFERENCE]
	}, s = {
		className: "meta",
		relevance: 10,
		begin: /^\s*['"]use strict['"]/
	}, c = {
		$pattern: $,
		keyword: St.concat([
			"type",
			"interface",
			"public",
			"private",
			"protected",
			"implements",
			"declare",
			"abstract",
			"readonly",
			"enum",
			"override",
			"satisfies"
		]),
		literal: Ct,
		built_in: Ot.concat(i),
		"variable.language": Dt
	}, l = {
		className: "meta",
		begin: "@" + r
	}, swapMode = (e, t, n) => {
		let r = e.contains.findIndex((e) => e.label === t);
		if (r === -1) throw Error("can not find mode to replace");
		e.contains.splice(r, 1, n);
	};
	Object.assign(n.keywords, c), n.exports.PARAMS_CONTAINS.push(l);
	let u = n.contains.find((e) => e.scope === "attr"), d = Object.assign({}, u, { match: t.concat(r, t.lookahead(/\s*\?:/)) });
	n.exports.PARAMS_CONTAINS.push([
		n.exports.CLASS_REFERENCE,
		u,
		d
	]), n.contains = n.contains.concat([
		l,
		a,
		o,
		d
	]), swapMode(n, "shebang", e.SHEBANG()), swapMode(n, "use_strict", s);
	let f = n.contains.find((e) => e.label === "func.def");
	return f.relevance = 0, Object.assign(n, {
		name: "TypeScript",
		aliases: [
			"ts",
			"tsx",
			"mts",
			"cts"
		]
	}), n;
}
//#endregion
//#region ../../node_modules/highlight.js/es/languages/css.js
var MODES = (e) => ({
	IMPORTANT: {
		scope: "meta",
		begin: "!important"
	},
	BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
	HEXCOLOR: {
		scope: "number",
		begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
	},
	FUNCTION_DISPATCH: {
		className: "built_in",
		begin: /[\w-]+(?=\()/
	},
	ATTRIBUTE_SELECTOR_MODE: {
		scope: "selector-attr",
		begin: /\[/,
		end: /\]/,
		illegal: "$",
		contains: [e.APOS_STRING_MODE, e.QUOTE_STRING_MODE]
	},
	CSS_NUMBER_MODE: {
		scope: "number",
		begin: e.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
		relevance: 0
	},
	CSS_VARIABLE: {
		className: "attr",
		begin: /--[A-Za-z_][A-Za-z0-9_-]*/
	}
}), kt = /* @__PURE__ */ "a.abbr.address.article.aside.audio.b.blockquote.body.button.canvas.caption.cite.code.dd.del.details.dfn.div.dl.dt.em.fieldset.figcaption.figure.footer.form.h1.h2.h3.h4.h5.h6.header.hgroup.html.i.iframe.img.input.ins.kbd.label.legend.li.main.mark.menu.nav.object.ol.optgroup.option.p.picture.q.quote.samp.section.select.source.span.strong.summary.sup.table.tbody.td.textarea.tfoot.th.thead.time.tr.ul.var.video".split("."), At = /* @__PURE__ */ "defs.g.marker.mask.pattern.svg.switch.symbol.feBlend.feColorMatrix.feComponentTransfer.feComposite.feConvolveMatrix.feDiffuseLighting.feDisplacementMap.feFlood.feGaussianBlur.feImage.feMerge.feMorphology.feOffset.feSpecularLighting.feTile.feTurbulence.linearGradient.radialGradient.stop.circle.ellipse.image.line.path.polygon.polyline.rect.text.use.textPath.tspan.foreignObject.clipPath".split("."), jt = [...kt, ...At], Mt = (/* @__PURE__ */ "any-hover.any-pointer.aspect-ratio.color.color-gamut.color-index.device-aspect-ratio.device-height.device-width.display-mode.forced-colors.grid.height.hover.inverted-colors.monochrome.orientation.overflow-block.overflow-inline.pointer.prefers-color-scheme.prefers-contrast.prefers-reduced-motion.prefers-reduced-transparency.resolution.scan.scripting.update.width.min-width.max-width.min-height.max-height".split(".")).sort().reverse(), Nt = (/* @__PURE__ */ "active.any-link.blank.checked.current.default.defined.dir.disabled.drop.empty.enabled.first.first-child.first-of-type.fullscreen.future.focus.focus-visible.focus-within.has.host.host-context.hover.indeterminate.in-range.invalid.is.lang.last-child.last-of-type.left.link.local-link.not.nth-child.nth-col.nth-last-child.nth-last-col.nth-last-of-type.nth-of-type.only-child.only-of-type.optional.out-of-range.past.placeholder-shown.read-only.read-write.required.right.root.scope.target.target-within.user-invalid.valid.visited.where".split(".")).sort().reverse(), Pt = [
	"after",
	"backdrop",
	"before",
	"cue",
	"cue-region",
	"first-letter",
	"first-line",
	"grammar-error",
	"marker",
	"part",
	"placeholder",
	"selection",
	"slotted",
	"spelling-error"
].sort().reverse(), Ft = (/* @__PURE__ */ "accent-color.align-content.align-items.align-self.alignment-baseline.all.anchor-name.animation.animation-composition.animation-delay.animation-direction.animation-duration.animation-fill-mode.animation-iteration-count.animation-name.animation-play-state.animation-range.animation-range-end.animation-range-start.animation-timeline.animation-timing-function.appearance.aspect-ratio.backdrop-filter.backface-visibility.background.background-attachment.background-blend-mode.background-clip.background-color.background-image.background-origin.background-position.background-position-x.background-position-y.background-repeat.background-size.baseline-shift.block-size.border.border-block.border-block-color.border-block-end.border-block-end-color.border-block-end-style.border-block-end-width.border-block-start.border-block-start-color.border-block-start-style.border-block-start-width.border-block-style.border-block-width.border-bottom.border-bottom-color.border-bottom-left-radius.border-bottom-right-radius.border-bottom-style.border-bottom-width.border-collapse.border-color.border-end-end-radius.border-end-start-radius.border-image.border-image-outset.border-image-repeat.border-image-slice.border-image-source.border-image-width.border-inline.border-inline-color.border-inline-end.border-inline-end-color.border-inline-end-style.border-inline-end-width.border-inline-start.border-inline-start-color.border-inline-start-style.border-inline-start-width.border-inline-style.border-inline-width.border-left.border-left-color.border-left-style.border-left-width.border-radius.border-right.border-right-color.border-right-style.border-right-width.border-spacing.border-start-end-radius.border-start-start-radius.border-style.border-top.border-top-color.border-top-left-radius.border-top-right-radius.border-top-style.border-top-width.border-width.bottom.box-align.box-decoration-break.box-direction.box-flex.box-flex-group.box-lines.box-ordinal-group.box-orient.box-pack.box-shadow.box-sizing.break-after.break-before.break-inside.caption-side.caret-color.clear.clip.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.color-scheme.column-count.column-fill.column-gap.column-rule.column-rule-color.column-rule-style.column-rule-width.column-span.column-width.columns.contain.contain-intrinsic-block-size.contain-intrinsic-height.contain-intrinsic-inline-size.contain-intrinsic-size.contain-intrinsic-width.container.container-name.container-type.content.content-visibility.counter-increment.counter-reset.counter-set.cue.cue-after.cue-before.cursor.cx.cy.direction.display.dominant-baseline.empty-cells.enable-background.field-sizing.fill.fill-opacity.fill-rule.filter.flex.flex-basis.flex-direction.flex-flow.flex-grow.flex-shrink.flex-wrap.float.flood-color.flood-opacity.flow.font.font-display.font-family.font-feature-settings.font-kerning.font-language-override.font-optical-sizing.font-palette.font-size.font-size-adjust.font-smooth.font-smoothing.font-stretch.font-style.font-synthesis.font-synthesis-position.font-synthesis-small-caps.font-synthesis-style.font-synthesis-weight.font-variant.font-variant-alternates.font-variant-caps.font-variant-east-asian.font-variant-emoji.font-variant-ligatures.font-variant-numeric.font-variant-position.font-variation-settings.font-weight.forced-color-adjust.gap.glyph-orientation-horizontal.glyph-orientation-vertical.grid.grid-area.grid-auto-columns.grid-auto-flow.grid-auto-rows.grid-column.grid-column-end.grid-column-start.grid-gap.grid-row.grid-row-end.grid-row-start.grid-template.grid-template-areas.grid-template-columns.grid-template-rows.hanging-punctuation.height.hyphenate-character.hyphenate-limit-chars.hyphens.icon.image-orientation.image-rendering.image-resolution.ime-mode.initial-letter.initial-letter-align.inline-size.inset.inset-area.inset-block.inset-block-end.inset-block-start.inset-inline.inset-inline-end.inset-inline-start.isolation.justify-content.justify-items.justify-self.kerning.left.letter-spacing.lighting-color.line-break.line-height.line-height-step.list-style.list-style-image.list-style-position.list-style-type.margin.margin-block.margin-block-end.margin-block-start.margin-bottom.margin-inline.margin-inline-end.margin-inline-start.margin-left.margin-right.margin-top.margin-trim.marker.marker-end.marker-mid.marker-start.marks.mask.mask-border.mask-border-mode.mask-border-outset.mask-border-repeat.mask-border-slice.mask-border-source.mask-border-width.mask-clip.mask-composite.mask-image.mask-mode.mask-origin.mask-position.mask-repeat.mask-size.mask-type.masonry-auto-flow.math-depth.math-shift.math-style.max-block-size.max-height.max-inline-size.max-width.min-block-size.min-height.min-inline-size.min-width.mix-blend-mode.nav-down.nav-index.nav-left.nav-right.nav-up.none.normal.object-fit.object-position.offset.offset-anchor.offset-distance.offset-path.offset-position.offset-rotate.opacity.order.orphans.outline.outline-color.outline-offset.outline-style.outline-width.overflow.overflow-anchor.overflow-block.overflow-clip-margin.overflow-inline.overflow-wrap.overflow-x.overflow-y.overlay.overscroll-behavior.overscroll-behavior-block.overscroll-behavior-inline.overscroll-behavior-x.overscroll-behavior-y.padding.padding-block.padding-block-end.padding-block-start.padding-bottom.padding-inline.padding-inline-end.padding-inline-start.padding-left.padding-right.padding-top.page.page-break-after.page-break-before.page-break-inside.paint-order.pause.pause-after.pause-before.perspective.perspective-origin.place-content.place-items.place-self.pointer-events.position.position-anchor.position-visibility.print-color-adjust.quotes.r.resize.rest.rest-after.rest-before.right.rotate.row-gap.ruby-align.ruby-position.scale.scroll-behavior.scroll-margin.scroll-margin-block.scroll-margin-block-end.scroll-margin-block-start.scroll-margin-bottom.scroll-margin-inline.scroll-margin-inline-end.scroll-margin-inline-start.scroll-margin-left.scroll-margin-right.scroll-margin-top.scroll-padding.scroll-padding-block.scroll-padding-block-end.scroll-padding-block-start.scroll-padding-bottom.scroll-padding-inline.scroll-padding-inline-end.scroll-padding-inline-start.scroll-padding-left.scroll-padding-right.scroll-padding-top.scroll-snap-align.scroll-snap-stop.scroll-snap-type.scroll-timeline.scroll-timeline-axis.scroll-timeline-name.scrollbar-color.scrollbar-gutter.scrollbar-width.shape-image-threshold.shape-margin.shape-outside.shape-rendering.speak.speak-as.src.stop-color.stop-opacity.stroke.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.tab-size.table-layout.text-align.text-align-all.text-align-last.text-anchor.text-combine-upright.text-decoration.text-decoration-color.text-decoration-line.text-decoration-skip.text-decoration-skip-ink.text-decoration-style.text-decoration-thickness.text-emphasis.text-emphasis-color.text-emphasis-position.text-emphasis-style.text-indent.text-justify.text-orientation.text-overflow.text-rendering.text-shadow.text-size-adjust.text-transform.text-underline-offset.text-underline-position.text-wrap.text-wrap-mode.text-wrap-style.timeline-scope.top.touch-action.transform.transform-box.transform-origin.transform-style.transition.transition-behavior.transition-delay.transition-duration.transition-property.transition-timing-function.translate.unicode-bidi.user-modify.user-select.vector-effect.vertical-align.view-timeline.view-timeline-axis.view-timeline-inset.view-timeline-name.view-transition-name.visibility.voice-balance.voice-duration.voice-family.voice-pitch.voice-range.voice-rate.voice-stress.voice-volume.white-space.white-space-collapse.widows.width.will-change.word-break.word-spacing.word-wrap.writing-mode.x.y.z-index.zoom".split(".")).sort().reverse();
function css(e) {
	let t = e.regex, n = MODES(e), r = { begin: /-(webkit|moz|ms|o)-(?=[a-z])/ }, i = /@-?\w[\w]*(-\w+)*/, a = [e.APOS_STRING_MODE, e.QUOTE_STRING_MODE];
	return {
		name: "CSS",
		case_insensitive: !0,
		illegal: /[=|'\$]/,
		keywords: { keyframePosition: "from to" },
		classNameAliases: { keyframePosition: "selector-tag" },
		contains: [
			n.BLOCK_COMMENT,
			r,
			n.CSS_NUMBER_MODE,
			{
				className: "selector-id",
				begin: /#[A-Za-z0-9_-]+/,
				relevance: 0
			},
			{
				className: "selector-class",
				begin: "\\.[a-zA-Z-][a-zA-Z0-9_-]*",
				relevance: 0
			},
			n.ATTRIBUTE_SELECTOR_MODE,
			{
				className: "selector-pseudo",
				variants: [{ begin: ":(" + Nt.join("|") + ")" }, { begin: ":(:)?(" + Pt.join("|") + ")" }]
			},
			n.CSS_VARIABLE,
			{
				className: "attribute",
				begin: "\\b(" + Ft.join("|") + ")\\b"
			},
			{
				begin: /:/,
				end: /[;}{]/,
				contains: [
					n.BLOCK_COMMENT,
					n.HEXCOLOR,
					n.IMPORTANT,
					n.CSS_NUMBER_MODE,
					...a,
					{
						begin: /(url|data-uri)\(/,
						end: /\)/,
						relevance: 0,
						keywords: { built_in: "url data-uri" },
						contains: [...a, {
							className: "string",
							begin: /[^)]/,
							endsWithParent: !0,
							excludeEnd: !0
						}]
					},
					n.FUNCTION_DISPATCH
				]
			},
			{
				begin: t.lookahead(/@/),
				end: "[{;]",
				relevance: 0,
				illegal: /:/,
				contains: [{
					className: "keyword",
					begin: i
				}, {
					begin: /\s/,
					endsWithParent: !0,
					excludeEnd: !0,
					relevance: 0,
					keywords: {
						$pattern: /[a-z-]+/,
						keyword: "and or not only",
						attribute: Mt.join(" ")
					},
					contains: [
						{
							begin: /[a-z-]+(?=:)/,
							className: "attribute"
						},
						...a,
						n.CSS_NUMBER_MODE
					]
				}]
			},
			{
				className: "selector-tag",
				begin: "\\b(" + jt.join("|") + ")\\b"
			}
		]
	};
}
//#endregion
//#region ../../node_modules/highlight.js/es/languages/xml.js
function xml(e) {
	let t = e.regex, n = t.concat(/[\p{L}_]/u, t.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), r = /[\p{L}0-9._:-]+/u, i = {
		className: "symbol",
		begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
	}, a = {
		begin: /\s/,
		contains: [{
			className: "keyword",
			begin: /#?[a-z_][a-z1-9_-]+/,
			illegal: /\n/
		}]
	}, o = e.inherit(a, {
		begin: /\(/,
		end: /\)/
	}), s = e.inherit(e.APOS_STRING_MODE, { className: "string" }), c = e.inherit(e.QUOTE_STRING_MODE, { className: "string" }), l = {
		endsWithParent: !0,
		illegal: /</,
		relevance: 0,
		contains: [{
			className: "attr",
			begin: r,
			relevance: 0
		}, {
			begin: /=\s*/,
			relevance: 0,
			contains: [{
				className: "string",
				endsParent: !0,
				variants: [
					{
						begin: /"/,
						end: /"/,
						contains: [i]
					},
					{
						begin: /'/,
						end: /'/,
						contains: [i]
					},
					{ begin: /[^\s"'=<>`]+/ }
				]
			}]
		}]
	};
	return {
		name: "HTML, XML",
		aliases: [
			"html",
			"xhtml",
			"rss",
			"atom",
			"xjb",
			"xsd",
			"xsl",
			"plist",
			"wsf",
			"svg"
		],
		case_insensitive: !0,
		unicodeRegex: !0,
		contains: [
			{
				className: "meta",
				begin: /<![a-z]/,
				end: />/,
				relevance: 10,
				contains: [
					a,
					c,
					s,
					o,
					{
						begin: /\[/,
						end: /\]/,
						contains: [{
							className: "meta",
							begin: /<![a-z]/,
							end: />/,
							contains: [
								a,
								o,
								c,
								s
							]
						}]
					}
				]
			},
			e.COMMENT(/<!--/, /-->/, { relevance: 10 }),
			{
				begin: /<!\[CDATA\[/,
				end: /\]\]>/,
				relevance: 10
			},
			i,
			{
				className: "meta",
				end: /\?>/,
				variants: [{
					begin: /<\?xml/,
					relevance: 10,
					contains: [c]
				}, { begin: /<\?[a-z][a-z0-9]+/ }]
			},
			{
				className: "tag",
				begin: /<style(?=\s|>)/,
				end: />/,
				keywords: { name: "style" },
				contains: [l],
				starts: {
					end: /<\/style>/,
					returnEnd: !0,
					subLanguage: ["css", "xml"]
				}
			},
			{
				className: "tag",
				begin: /<script(?=\s|>)/,
				end: />/,
				keywords: { name: "script" },
				contains: [l],
				starts: {
					end: /<\/script>/,
					returnEnd: !0,
					subLanguage: [
						"javascript",
						"handlebars",
						"xml"
					]
				}
			},
			{
				className: "tag",
				begin: /<>|<\/>/
			},
			{
				className: "tag",
				begin: t.concat(/</, t.lookahead(t.concat(n, t.either(/\/>/, />/, /\s/)))),
				end: /\/?>/,
				contains: [{
					className: "name",
					begin: n,
					relevance: 0,
					starts: l
				}]
			},
			{
				className: "tag",
				begin: t.concat(/<\//, t.lookahead(t.concat(n, />/))),
				contains: [{
					className: "name",
					begin: n,
					relevance: 0
				}, {
					begin: />/,
					relevance: 0,
					endsParent: !0
				}]
			}
		]
	};
}
//#endregion
//#region ../../node_modules/highlight.js/es/languages/bash.js
function bash(e) {
	let t = e.regex, n = {}, r = {
		begin: /\$\{/,
		end: /\}/,
		contains: ["self", {
			begin: /:-/,
			contains: [n]
		}]
	};
	Object.assign(n, {
		className: "variable",
		variants: [{ begin: t.concat(/\$[\w\d#@][\w\d_]*/, "(?![\\w\\d])(?![$])") }, r]
	});
	let i = {
		className: "subst",
		begin: /\$\(/,
		end: /\)/,
		contains: [e.BACKSLASH_ESCAPE]
	}, a = e.inherit(e.COMMENT(), {
		match: [/(^|\s)/, /#.*$/],
		scope: { 2: "comment" }
	}), o = {
		begin: /<<-?\s*(?=\w+)/,
		starts: { contains: [e.END_SAME_AS_BEGIN({
			begin: /(\w+)/,
			end: /(\w+)/,
			className: "string"
		})] }
	}, s = {
		className: "string",
		begin: /"/,
		end: /"/,
		contains: [
			e.BACKSLASH_ESCAPE,
			n,
			i
		]
	};
	i.contains.push(s);
	let c = { match: /\\"/ }, l = {
		className: "string",
		begin: /'/,
		end: /'/
	}, u = { match: /\\'/ }, d = {
		begin: /\$?\(\(/,
		end: /\)\)/,
		contains: [
			{
				begin: /\d+#[0-9a-f]+/,
				className: "number"
			},
			e.NUMBER_MODE,
			n
		]
	}, f = e.SHEBANG({
		binary: `(${[
			"fish",
			"bash",
			"zsh",
			"sh",
			"csh",
			"ksh",
			"tcsh",
			"dash",
			"scsh"
		].join("|")})`,
		relevance: 10
	}), p = {
		className: "function",
		begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
		returnBegin: !0,
		contains: [e.inherit(e.TITLE_MODE, { begin: /\w[\w\d_]*/ })],
		relevance: 0
	}, m = [
		"if",
		"then",
		"else",
		"elif",
		"fi",
		"time",
		"for",
		"while",
		"until",
		"in",
		"do",
		"done",
		"case",
		"esac",
		"coproc",
		"function",
		"select"
	], h = ["true", "false"], g = { match: /(\/[a-z._-]+)+/ }, _ = [
		"break",
		"cd",
		"continue",
		"eval",
		"exec",
		"exit",
		"export",
		"getopts",
		"hash",
		"pwd",
		"readonly",
		"return",
		"shift",
		"test",
		"times",
		"trap",
		"umask",
		"unset"
	], v = [
		"alias",
		"bind",
		"builtin",
		"caller",
		"command",
		"declare",
		"echo",
		"enable",
		"help",
		"let",
		"local",
		"logout",
		"mapfile",
		"printf",
		"read",
		"readarray",
		"source",
		"sudo",
		"type",
		"typeset",
		"ulimit",
		"unalias"
	], y = /* @__PURE__ */ "autoload.bg.bindkey.bye.cap.chdir.clone.comparguments.compcall.compctl.compdescribe.compfiles.compgroups.compquote.comptags.comptry.compvalues.dirs.disable.disown.echotc.echoti.emulate.fc.fg.float.functions.getcap.getln.history.integer.jobs.kill.limit.log.noglob.popd.print.pushd.pushln.rehash.sched.setcap.setopt.stat.suspend.ttyctl.unfunction.unhash.unlimit.unsetopt.vared.wait.whence.where.which.zcompile.zformat.zftp.zle.zmodload.zparseopts.zprof.zpty.zregexparse.zsocket.zstyle.ztcp".split("."), b = /* @__PURE__ */ "chcon.chgrp.chown.chmod.cp.dd.df.dir.dircolors.ln.ls.mkdir.mkfifo.mknod.mktemp.mv.realpath.rm.rmdir.shred.sync.touch.truncate.vdir.b2sum.base32.base64.cat.cksum.comm.csplit.cut.expand.fmt.fold.head.join.md5sum.nl.numfmt.od.paste.ptx.pr.sha1sum.sha224sum.sha256sum.sha384sum.sha512sum.shuf.sort.split.sum.tac.tail.tr.tsort.unexpand.uniq.wc.arch.basename.chroot.date.dirname.du.echo.env.expr.factor.groups.hostid.id.link.logname.nice.nohup.nproc.pathchk.pinky.printenv.printf.pwd.readlink.runcon.seq.sleep.stat.stdbuf.stty.tee.test.timeout.tty.uname.unlink.uptime.users.who.whoami.yes".split(".");
	return {
		name: "Bash",
		aliases: ["sh", "zsh"],
		keywords: {
			$pattern: /\b[a-z][a-z0-9._-]+\b/,
			keyword: m,
			literal: h,
			built_in: [
				..._,
				...v,
				"set",
				"shopt",
				...y,
				...b
			]
		},
		contains: [
			f,
			e.SHEBANG(),
			p,
			d,
			a,
			o,
			g,
			s,
			c,
			l,
			u,
			n
		]
	};
}
//#endregion
//#region ../../node_modules/highlight.js/es/languages/json.js
function json(e) {
	let t = {
		className: "attr",
		begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
		relevance: 1.01
	}, n = {
		match: /[{}[\],:]/,
		className: "punctuation",
		relevance: 0
	}, r = [
		"true",
		"false",
		"null"
	], i = {
		scope: "literal",
		beginKeywords: r.join(" ")
	};
	return {
		name: "JSON",
		aliases: ["jsonc"],
		keywords: { literal: r },
		contains: [
			t,
			n,
			e.QUOTE_STRING_MODE,
			i,
			e.C_NUMBER_MODE,
			e.C_LINE_COMMENT_MODE,
			e.C_BLOCK_COMMENT_MODE
		],
		illegal: "\\S"
	};
}
//#endregion
//#region ../../node_modules/highlight.js/es/languages/go.js
function go(e) {
	let t = {
		keyword: [
			"break",
			"case",
			"chan",
			"const",
			"continue",
			"default",
			"defer",
			"else",
			"fallthrough",
			"for",
			"func",
			"go",
			"goto",
			"if",
			"import",
			"interface",
			"map",
			"package",
			"range",
			"return",
			"select",
			"struct",
			"switch",
			"type",
			"var"
		],
		type: [
			"bool",
			"byte",
			"complex64",
			"complex128",
			"error",
			"float32",
			"float64",
			"int8",
			"int16",
			"int32",
			"int64",
			"string",
			"uint8",
			"uint16",
			"uint32",
			"uint64",
			"int",
			"uint",
			"uintptr",
			"rune"
		],
		literal: [
			"true",
			"false",
			"iota",
			"nil"
		],
		built_in: [
			"append",
			"cap",
			"close",
			"complex",
			"copy",
			"imag",
			"len",
			"make",
			"new",
			"panic",
			"print",
			"println",
			"real",
			"recover",
			"delete"
		]
	};
	return {
		name: "Go",
		aliases: ["golang"],
		keywords: t,
		illegal: "</",
		contains: [
			e.C_LINE_COMMENT_MODE,
			e.C_BLOCK_COMMENT_MODE,
			{
				className: "string",
				variants: [
					e.QUOTE_STRING_MODE,
					e.APOS_STRING_MODE,
					{
						begin: "`",
						end: "`"
					}
				]
			},
			{
				className: "number",
				variants: [
					{
						match: /-?\b0[xX]\.[a-fA-F0-9](_?[a-fA-F0-9])*[pP][+-]?\d(_?\d)*i?/,
						relevance: 0
					},
					{
						match: /-?\b0[xX](_?[a-fA-F0-9])+((\.([a-fA-F0-9](_?[a-fA-F0-9])*)?)?[pP][+-]?\d(_?\d)*)?i?/,
						relevance: 0
					},
					{
						match: /-?\b0[oO](_?[0-7])*i?/,
						relevance: 0
					},
					{
						match: /-?\.\d(_?\d)*([eE][+-]?\d(_?\d)*)?i?/,
						relevance: 0
					},
					{
						match: /-?\b\d(_?\d)*(\.(\d(_?\d)*)?)?([eE][+-]?\d(_?\d)*)?i?/,
						relevance: 0
					}
				]
			},
			{ begin: /:=/ },
			{
				className: "function",
				beginKeywords: "func",
				end: "\\s*(\\{|$)",
				excludeEnd: !0,
				contains: [e.TITLE_MODE, {
					className: "params",
					begin: /\(/,
					end: /\)/,
					endsParent: !0,
					keywords: t,
					illegal: /["']/
				}]
			}
		]
	};
}
//#endregion
//#region ../../node_modules/highlight.js/es/languages/python.js
function python(e) {
	let t = e.regex, n = /[\p{XID_Start}_]\p{XID_Continue}*/u, r = /* @__PURE__ */ "and.as.assert.async.await.break.case.class.continue.def.del.elif.else.except.finally.for.from.global.if.import.in.is.lambda.match.nonlocal|10.not.or.pass.raise.return.try.while.with.yield".split("."), i = {
		$pattern: /[A-Za-z]\w+|__\w+__/,
		keyword: r,
		built_in: /* @__PURE__ */ "__import__.abs.all.any.ascii.bin.bool.breakpoint.bytearray.bytes.callable.chr.classmethod.compile.complex.delattr.dict.dir.divmod.enumerate.eval.exec.filter.float.format.frozenset.getattr.globals.hasattr.hash.help.hex.id.input.int.isinstance.issubclass.iter.len.list.locals.map.max.memoryview.min.next.object.oct.open.ord.pow.print.property.range.repr.reversed.round.set.setattr.slice.sorted.staticmethod.str.sum.super.tuple.type.vars.zip".split("."),
		literal: [
			"__debug__",
			"Ellipsis",
			"False",
			"None",
			"NotImplemented",
			"True"
		],
		type: [
			"Any",
			"Callable",
			"Coroutine",
			"Dict",
			"List",
			"Literal",
			"Generic",
			"Optional",
			"Sequence",
			"Set",
			"Tuple",
			"Type",
			"Union"
		]
	}, a = {
		className: "meta",
		begin: /^(>>>|\.\.\.) /
	}, o = {
		className: "subst",
		begin: /\{/,
		end: /\}/,
		keywords: i,
		illegal: /#/
	}, s = {
		begin: /\{\{/,
		relevance: 0
	}, c = {
		className: "string",
		contains: [e.BACKSLASH_ESCAPE],
		variants: [
			{
				begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
				end: /'''/,
				contains: [e.BACKSLASH_ESCAPE, a],
				relevance: 10
			},
			{
				begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
				end: /"""/,
				contains: [e.BACKSLASH_ESCAPE, a],
				relevance: 10
			},
			{
				begin: /([fF][rR]|[rR][fF]|[fF])'''/,
				end: /'''/,
				contains: [
					e.BACKSLASH_ESCAPE,
					a,
					s,
					o
				]
			},
			{
				begin: /([fF][rR]|[rR][fF]|[fF])"""/,
				end: /"""/,
				contains: [
					e.BACKSLASH_ESCAPE,
					a,
					s,
					o
				]
			},
			{
				begin: /([uU]|[rR])'/,
				end: /'/,
				relevance: 10
			},
			{
				begin: /([uU]|[rR])"/,
				end: /"/,
				relevance: 10
			},
			{
				begin: /([bB]|[bB][rR]|[rR][bB])'/,
				end: /'/
			},
			{
				begin: /([bB]|[bB][rR]|[rR][bB])"/,
				end: /"/
			},
			{
				begin: /([fF][rR]|[rR][fF]|[fF])'/,
				end: /'/,
				contains: [
					e.BACKSLASH_ESCAPE,
					s,
					o
				]
			},
			{
				begin: /([fF][rR]|[rR][fF]|[fF])"/,
				end: /"/,
				contains: [
					e.BACKSLASH_ESCAPE,
					s,
					o
				]
			},
			e.APOS_STRING_MODE,
			e.QUOTE_STRING_MODE
		]
	}, l = "[0-9](_?[0-9])*", u = `(\\b(${l}))?\\.(${l})|\\b(${l})\\.`, d = `\\b|${r.join("|")}`, f = {
		className: "number",
		relevance: 0,
		variants: [
			{ begin: `(\\b(${l})|(${u}))[eE][+-]?(${l})[jJ]?(?=${d})` },
			{ begin: `(${u})[jJ]?` },
			{ begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${d})` },
			{ begin: `\\b0[bB](_?[01])+[lL]?(?=${d})` },
			{ begin: `\\b0[oO](_?[0-7])+[lL]?(?=${d})` },
			{ begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${d})` },
			{ begin: `\\b(${l})[jJ](?=${d})` }
		]
	}, p = {
		className: "comment",
		begin: t.lookahead(/# type:/),
		end: /$/,
		keywords: i,
		contains: [{ begin: /# type:/ }, {
			begin: /#/,
			end: /\b\B/,
			endsWithParent: !0
		}]
	}, m = {
		className: "params",
		variants: [{
			className: "",
			begin: /\(\s*\)/,
			skip: !0
		}, {
			begin: /\(/,
			end: /\)/,
			excludeBegin: !0,
			excludeEnd: !0,
			keywords: i,
			contains: [
				"self",
				a,
				f,
				c,
				e.HASH_COMMENT_MODE
			]
		}]
	};
	return o.contains = [
		c,
		f,
		a
	], {
		name: "Python",
		aliases: [
			"py",
			"gyp",
			"ipython"
		],
		unicodeRegex: !0,
		keywords: i,
		illegal: /(<\/|\?)|=>/,
		contains: [
			a,
			f,
			{
				scope: "variable.language",
				match: /\bself\b/
			},
			{
				beginKeywords: "if",
				relevance: 0
			},
			{
				match: /\bor\b/,
				scope: "keyword"
			},
			c,
			p,
			e.HASH_COMMENT_MODE,
			{
				match: [
					/\bdef/,
					/\s+/,
					n
				],
				scope: {
					1: "keyword",
					3: "title.function"
				},
				contains: [m]
			},
			{
				variants: [{ match: [
					/\bclass/,
					/\s+/,
					n,
					/\s*/,
					/\(\s*/,
					n,
					/\s*\)/
				] }, { match: [
					/\bclass/,
					/\s+/,
					n
				] }],
				scope: {
					1: "keyword",
					3: "title.class",
					6: "title.class.inherited"
				}
			},
			{
				className: "meta",
				begin: /^[\t ]*@/,
				end: /(?=#)|$/,
				contains: [
					f,
					m,
					c
				]
			}
		]
	};
}
//#endregion
//#region src/components/cardRendering/CodeBlockRenderer.vue?vue&type=script&setup=true&lang.ts
var It = { class: "code-block-wrapper pa-2" }, Lt = {
	key: 0,
	class: "language-indicator"
}, Rt = /* @__PURE__ */ l({
	__name: "CodeBlockRenderer",
	props: {
		code: {
			type: String,
			required: !0
		},
		language: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		Q.registerLanguage("js", javascript$1), Q.registerLanguage("javascript", javascript$1), Q.registerLanguage("ts", typescript), Q.registerLanguage("typescript", typescript), Q.registerLanguage("css", css), Q.registerLanguage("html", xml), Q.registerLanguage("bash", bash), Q.registerLanguage("sh", bash), Q.registerLanguage("json", json), Q.registerLanguage("go", go), Q.registerLanguage("golang", go), Q.registerLanguage("python", python);
		let t = u();
		return t && t.appContext.app.component("highlightjs", pt.component), (t, n) => {
			let a = x("highlightjs");
			return v(), i("div", It, [e.language ? (v(), i("div", Lt, C(e.language), 1)) : r("", !0), s(a, {
				language: e.language,
				code: e.code
			}, null, 8, ["language", "code"])]);
		};
	}
}), zt = { key: 0 }, Bt = { key: 0 }, Vt = { key: 0 }, Ht = {
	key: 1,
	class: "error--text"
}, Ut = { key: 1 }, Wt = { key: 2 }, Gt = { key: 1 }, Kt = { key: 1 }, qt = {
	key: 0,
	class: "text-h2"
}, Jt = {
	key: 1,
	class: "text-h3"
}, Yt = {
	key: 2,
	class: "text-h4"
}, Xt = { key: 3 }, Zt = { key: 4 }, Qt = { key: 5 }, $t = { key: 2 }, en = {
	key: 3,
	class: "text-h5"
}, tn = { key: 0 }, nn = ["href", "title"], rn = { key: 5 }, an = { key: 6 }, on = { key: 7 }, sn = ["src", "alt"], cn = { key: 9 }, ln = { key: 10 }, un = { key: 11 }, dn = ["align"], fn = ["innerHTML"], pn = ["innerHTML"], mn = { key: 16 }, hn = { key: 17 }, gn = { key: 18 }, _n = /* @__PURE__ */ F(/* @__PURE__ */ l({
	__name: "MdTokenRenderer",
	props: {
		token: {
			type: Object,
			required: !0
		},
		last: {
			type: Boolean,
			required: !1,
			default: !1
		}
	},
	setup(t, { expose: o }) {
		let s = f("markdownComponents", {}), c = {
			fillIn: p(he),
			...s
		};
		function isComponent$1(e) {
			return isComponent(e);
		}
		__name(isComponent$1, "isComponent");
		function containsComponent$1(e) {
			return containsComponent(e);
		}
		__name(containsComponent$1, "containsComponent");
		function splitTextToken$1(e) {
			return splitTextToken(e);
		}
		__name(splitTextToken$1, "splitTextToken");
		function splitParagraphToken$1(e) {
			return splitParagraphToken(e);
		}
		__name(splitParagraphToken$1, "splitParagraphToken");
		function parsedComponent(e) {
			let t = "";
			"text" in e && typeof e.text == "string" ? t = e.text : "raw" in e && typeof e.raw == "string" && (t = e.raw);
			let n = parseComponentSyntax(t);
			return n ? {
				is: n.componentName,
				text: "",
				props: n.props
			} : {
				is: "fillIn",
				text: t,
				props: {}
			};
		}
		function getComponent(e) {
			return c[e] || (console.warn(`[MarkdownRenderer] Unknown component: "${e}". Available components: ${Object.keys(c).join(", ")}`), null);
		}
		function decodeBasicEntities(e) {
			return e.replace(/&#39;/g, "'").replace(/&quot;/g, "\"").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
		}
		function isText(e) {
			return e.inLink === void 0 && e.type === "text";
		}
		return o({
			isComponent: isComponent$1,
			containsComponent: containsComponent$1,
			splitTextToken: splitTextToken$1,
			splitParagraphToken: splitParagraphToken$1,
			parsedComponent,
			decodeBasicEntities,
			isText,
			components: c,
			getComponent
		}), (o, s) => {
			let c = x("md-token-renderer", !0);
			return isText(t.token) ? (v(), i("span", zt, [!t.token.tokens || t.token.tokens.length === 0 ? (v(), i("span", Bt, [isComponent$1(t.token) ? (v(), i("span", Vt, [!t.last && getComponent(parsedComponent(t.token).is) ? (v(), n(S(getComponent(parsedComponent(t.token).is)), m({
				key: 0,
				text: parsedComponent(t.token).text
			}, parsedComponent(t.token).props), null, 16, ["text"])) : !t.last && !getComponent(parsedComponent(t.token).is) ? (v(), i("span", Ht, " [Unknown component: " + C(parsedComponent(t.token).is) + "] ", 1)) : r("", !0)])) : containsComponent$1(t.token) ? (v(), i("span", Ut, [(v(!0), i(e, null, b(splitTextToken$1(t.token), (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : (v(), i("span", Wt, C(decodeBasicEntities(t.token.text)), 1))])) : t.token.tokens && t.token.tokens.length !== 0 ? (v(), i("span", Gt, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : r("", !0)])) : t.token.type === "heading" ? (v(), i("span", Kt, [t.token.depth === 1 ? (v(), i("h1", qt, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.depth === 2 ? (v(), i("h2", Jt, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.depth === 3 ? (v(), i("h3", Yt, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.depth === 4 ? (v(), i("h4", Xt, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.depth === 5 ? (v(), i("h5", Zt, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.depth === 6 ? (v(), i("h6", Qt, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : r("", !0)])) : t.token.type === "strong" ? (v(), i("strong", $t, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.type === "paragraph" ? (v(), i("p", en, [containsComponent$1(t.token) ? (v(), i("span", tn, [(v(!0), i(e, null, b(splitParagraphToken$1(t.token), (e, r) => (v(), n(c, {
				key: r,
				token: e,
				last: t.last && t.token.tokens.length === 1 && r === splitParagraphToken$1(t.token).length - 1
			}, null, 8, ["token", "last"]))), 128))])) : (v(!0), i(e, { key: 1 }, b(t.token.tokens, (e, r) => (v(), n(c, {
				key: r,
				token: e,
				last: t.last && t.token.tokens.length === 1
			}, null, 8, ["token", "last"]))), 128))])) : t.token.type === "link" ? (v(), i("a", {
				key: 4,
				href: t.token.href,
				title: t.token.title
			}, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))], 8, nn)) : t.token.type === "list" && t.token.ordered === !1 ? (v(), i("ul", rn, [(v(!0), i(e, null, b(t.token.items, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.type === "list" && t.token.ordered === !0 ? (v(), i("ol", an, [(v(!0), i(e, null, b(t.token.items, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.type === "list_item" ? (v(), i("li", on, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.type === "image" ? (v(), i("img", {
				key: 8,
				src: t.token.href,
				alt: t.token.title
			}, null, 8, sn)) : t.token.type === "hr" ? (v(), i("hr", cn)) : t.token.type === "br" ? (v(), i("br", ln)) : t.token.type === "del" ? (v(), i("del", un)) : t.token.type === "table" ? (v(), i("table", {
				key: 12,
				align: t.token.align
			}, [a("thead", null, [(v(!0), i(e, null, b(t.token.header, (e, t) => (v(), i("th", { key: t }, C(e.text), 1))), 128))]), a("tbody", null, [(v(!0), i(e, null, b(t.token.rows, (t, n) => (v(), i("tr", { key: n }, [(v(!0), i(e, null, b(t, (e, t) => (v(), i("td", { key: t }, C(e.text), 1))), 128))]))), 128))])], 8, dn)) : t.token.type === "html" ? (v(), i("span", {
				key: 13,
				innerHTML: t.token.raw
			}, null, 8, fn)) : t.token.type === "code" ? (v(), n(Rt, {
				key: 14,
				code: t.token.text,
				language: t.token.lang
			}, null, 8, ["code", "language"])) : t.token.type === "codespan" ? (v(), i("code", {
				key: 15,
				class: "codespan",
				innerHTML: t.token.text
			}, null, 8, pn)) : t.token.type === "blockquote" ? (v(), i("blockquote", mn, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : t.token.type === "escape" ? (v(), i("span", hn, C(t.token.text), 1)) : t.token.type === "em" ? (v(), i("em", gn, [(v(!0), i(e, null, b(t.token.tokens, (e, t) => (v(), n(c, {
				key: t,
				token: e
			}, null, 8, ["token"]))), 128))])) : r("", !0);
		};
	}
}), [["__scopeId", "data-v-de3eebd6"]]), vn = l({
	name: "MarkdownRenderer",
	components: {
		MdTokenRenderer: _n,
		AudioAutoPlayer: dt
	},
	props: { md: {
		type: String,
		required: !0
	} },
	computed: { tokens() {
		return lt(this.md);
	} }
}), yn = /* @__PURE__ */ __exportAll({ default: () => bn });
function _sfc_render(t, a, o, s, c, l) {
	let u = x("md-token-renderer"), d = x("audio-auto-player");
	return v(), i("div", null, [(v(!0), i(e, null, b(t.tokens, (e, a) => (v(), i("span", { key: a }, [e.type ? (v(), n(u, {
		key: 0,
		token: e,
		last: a === t.tokens.length - 1
	}, null, 8, ["token", "last"])) : e.audio ? (v(), n(d, {
		key: 1,
		src: e.audio
	}, null, 8, ["src"])) : r("", !0)]))), 128))]);
}
var bn = /* @__PURE__ */ F(vn, [["render", _sfc_render]]);
//#endregion
export { I as C, __name as E, useViewable as S, F as T, useCardPreviewModeStore as _, dt as a, isQuestionView as b, isInlineComponent as c, splitByDelimiters as d, splitParagraphToken as f, ce as g, fe as h, Rt as i, parseComponentSyntax as l, he as m, yn as n, containsComponent as o, splitTextToken as p, _n as r, isComponent as s, bn as t, parseComponentToken as u, getPinia as v, _defineProperty as w, useQuestionView as x, se as y };

//# sourceMappingURL=MarkdownRenderer-U_iPiA2x.mjs.map